import GlobeIconSVG from "assets/svg/globe-icon";
import LineVerticalSVG from "assets/svg/line-vertical";
import NoProfileFoundIconSvg from "assets/svg/no-profile-found-icon-svg";
import PlayIconCircleWhiteSVG from "assets/svg/play-icon-circle-white";
import VerifyIconSVG from "assets/svg/verified-icon";
import SwitchProfileModal from "components/account/switch-profile-modal";
import LoginSingup from "components/auth-mobile/LoginSignup";
import Button from "components/button/button";
import GroupButton from "components/button/group-btn";
import Collapsible from "components/collapsible";
import FabButton from "components/fab-button/fab-button";
import DropzoneUploadMilestone from "components/file-upload/milestone-upload";
import GetStarted from "components/get-started/let-get-started";
import AlertBar from "components/global/alert-bar";
import PopInfo from "components/info-popup/pop-info";
import SendMessageModal from "components/message/send-message";
import LoadMore from "components/pagination/load-more";
import GroupMembers from "components/profile/about/GroupMembers";
import GroupTeam from "components/profile/about/GroupTeam";
import PersonalInformation from "components/profile/about/personal-information";
import ProfessionalInformation from "components/profile/about/professional-information";
import ProfileCoverPhoto from "components/profile/cover-photo";
import AddMilestoneModal from "components/profile/milestones/add-milestone-modal";
import AddQuickMilestone from "components/profile/milestones/add-quick-milestone";
import ColumnViewMilestones from "components/profile/milestones/column-view";
import { DetailedTagViewCard } from "components/profile/milestones/detailed-tag-view-card";
import DetailedViewMilestones from "components/profile/milestones/detailed-view";
import EditMilestoneModal from "components/profile/milestones/edit-milestone-modal";
import ListFilter from "components/profile/milestones/filters/list-filter";
import ListViewMilestones from "components/profile/milestones/list-view";
import ImageGalleryModal from "components/profile/milestones/media-button/image-gallery";
import PdfViewerModal from "components/profile/milestones/media-button/pdf-viewer";
import WatchMediaModal from "components/profile/milestones/media-button/watch";
import ConfirmDeleteModal from "components/profile/milestones/more-option/confirm-delete";
import ConfirmRemoveTagModal from "components/profile/milestones/more-option/confirm-remove-tag";
import { MenuBottom } from "components/profile/milestones/more-option/option-list-item";
import ReportMilestone from "components/profile/milestones/more-option/report";
import OrganizePositionDetailedListView from "components/profile/milestones/organize-position/detailed-view";
import OrganizePositionListView from "components/profile/milestones/organize-position/list-view";
import ShareMilestoneModal from "components/profile/milestones/share-milestone-modal";
import ViewMilestoneDialog from "components/profile/milestones/view-dialog";
import ManageVideos from "components/profile/photos-videos/manage-videos";
import PhotosVideos from "components/profile/photos-videos/photos-videos";
import ProfileDetails from "components/profile/profile-details";
import ProfilePhoto from "components/profile/profile-photo";
import ProfileSocials from "components/profile/profile-socials";
import ResumeList from "components/profile/resume/resume";
import SocialModal from "components/profile/share/socials";
import DefaultTabs from "components/profile/tabs";
import ToolTip from "components/tootltip/tootltip";
import { API_ENDPOINT } from "configs/api";
import {
  CoverDefaultPlaceholder,
  LogoWhite,
  ProfileDefaultPlaceholder,
} from "constants/images";
import { CATEGORY, DATE_NEWEST_TO_OLDEST, DATE_OLDEST_TO_NEWEST, JOB_ROLE } from "constants/options";
import { Context } from "context/context";
import { LangContext } from "context/language";
import { SubscriptionContext } from "context/subscription";
import { gsap } from "gsap";
import Layout from "layouts/layout";
import _ from "lodash";
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { TabPanel } from "react-headless-tabs";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { FaPlus } from "react-icons/fa";
import { GoStarFill } from "react-icons/go";
import { FiChevronUp, FiEye } from "react-icons/fi";
import { IoAddCircleOutline, IoCogSharp } from "react-icons/io5";
import { MdClose } from "react-icons/md";
import { connect } from "react-redux";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import Popup from "reactjs-popup";
import { useCategoryFilter } from "redux/modules/category-filter/hooks";
import { useMilestones } from "redux/modules/milestone/hooks";
import { usePositionFilter } from "redux/modules/position-filter/hooks";
import { useResume } from "redux/modules/resume/hooks";
import userActions from "redux/modules/user/actions";
import { heroIcon } from "utils/constant";
import { useDialogHook, useLocalStorage, useWindowDimensions } from "utils/customhooks";
import { compareDate, currentLang, formatDate, sortNoteLatest, sortOldest, urlSerializer } from "utils/utils";
import logo from '../../assets/images/logo.png';
import SkeletonLoading from "./Skeleton/skeletonloading";

const Profile = ({ userData, setUserData }) => {

  const { t,i18n } = useTranslation();

  const { http, localstorage } = global.services;
  let { username, profileId } = useParams();
  const { route, setRoute, setFollowing, setFollowers, updateMetaData, metaData } = useContext(Context);
  const {heroCTAs,heroTypes} = useContext(LangContext)
  const history = useHistory();
  const loc = useLocation();
  const [profile, setProfile] = useState({});
  const [hasProInfo, setHasProInfo] = useState(true);
  const [socMed, setSocMed] = useState([]);

  // Profile URL canonicalization (Marker.io MCF — "stop the random slug
  // fragmenting one profile into infinite URLs"). The app mints a throwaway
  // 4-char slug on nearly every render — /{username}-{rand}/profile/{id} — but
  // the public route resolves by profile id alone, so those variants are purely
  // cosmetic. Once the real profile has loaded, collapse the address bar to the
  // stable /{username}/profile/{id} and publish a matching rel=canonical so
  // shares, links, crawlers and path-based analytics consolidate on one URL.
  // We canonicalise to the authoritative username from the loaded profile (not
  // username.split("-")[0], which would mangle usernames containing a hyphen).
  useEffect(() => {
    const realUsername = profile?.user?.username;
    if (!realUsername || !profileId) return;

    const canonicalPath = `/${encodeURIComponent(realUsername)}/profile/${profileId}`;
    const canonicalHref = `${window.location.origin}${canonicalPath}`;

    // Keep a single rel=canonical in the SPA head in sync (the Laravel crawler
    // snapshot emits its own canonical; this covers client-rendered views).
    try {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      if (link.getAttribute("href") !== canonicalHref) {
        link.setAttribute("href", canonicalHref);
      }
    } catch (e) {
      /* non-fatal: head not available */
    }

    // Collapse the random-slug variant in the address bar, preserving the query
    // string and hash so ?showreel=true, ?milestone=…, ?aboutSection=true etc.
    // keep working.
    if (decodeURIComponent(username || "") !== realUsername) {
      history.replace(`${canonicalPath}${loc.search || ""}${loc.hash || ""}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile?.user?.username, profileId, username]);
  const isWithPersonalInfo = useMemo(() => {
    let hasInfo = false;
    // todo: checking
    const personalInfoProps = [
      'bio', 
      'birthdate', 
      'birth_location', 
      'civil_status', 
      'children', 
      'height',
      'hair_color'
    ];

    for(const item of personalInfoProps) {
      if(!!profile[item]) hasInfo = true;
    }

    return hasInfo; 
  } ,[profile]);

  const { setResumes,limit: limitResume, initialize:initializeResume,finishGetResume,getResume, 
    isRequesting:isRequestingResume,total: totalResume, loadMore: loadMoreResume, refreshResumes } = useResume();

  const [permission, setPermission] = useState(null);
  const shareModal = useDialogHook(SocialModal);
  const uploadMilestone = useDialogHook(DropzoneUploadMilestone);
  const { isMobile } = useWindowDimensions();
  // const [reportDetails, setReportDetails] = useState({
  //   milestone: {},
  //   open: false,
  // });
  const [selectedTab, setSelectedTab] = useLocalStorage(
    "profile-tab",
    "milestones",
    "photos-video",
    "tagged",
    "resume"
  );
  const containerStickyRef = useRef();
  const [isSticky,setIsSticky] = useState(false);
  const [options, setOptions] = useState({
    positions: [],
    categories: [],
  });
  const [view, setView] = useState("detailed");
  const [filterRoles, setFilterRoles] = useState([]);
  const [filterCategories, setFilterCategories] = useState([]);
  const optionListRef = useRef();
  const optionTriggerRef = useRef();
  const popupOpenedAt = useRef(0);
  const sendModal = useDialogHook(SendMessageModal);
  const modalAdd = useDialogHook(AddMilestoneModal);
  const modalEdit = useDialogHook(EditMilestoneModal);
  const watchMediaModal = useDialogHook(WatchMediaModal);
  const imageGalleryModal = useDialogHook(ImageGalleryModal);
  const pdfViewerModal = useDialogHook(PdfViewerModal);
  const modalDelete = useDialogHook(ConfirmDeleteModal);
  const modalRemoveTag = useDialogHook(ConfirmRemoveTagModal);
  const switchProfileModal = useDialogHook(SwitchProfileModal);
  const modalGetStarted = useDialogHook(GetStarted);
  const quickAddMile = useDialogHook(AddQuickMilestone);

  const [switchingProfile, setSwitchingProfile] = useState(false);
  //
  const modalShare = useDialogHook(ShareMilestoneModal);
  const [_status, setStatus] = useState("");
  //
  const [scrollToTop, setScrollToTop] = useState(0);
  const modalReport = useDialogHook(ReportMilestone);
  const modalViewMilestone = useDialogHook(ViewMilestoneDialog);
  const [showNoProfileFound, setShowNoProfileFound] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [showTutMilestone,setTutMile] = useState(null); 
  const [showMoreOptionMile,setShowMoreOptionMile] = useState(false)
  const [fetchSocMed, setFetchSocMed] = useState({social_media:[], follow:null});
  const [showOnboarding,setOnboarding] = useState(true) //once this is true then hide the premium footer

  const contentRef = useRef();
  const profileRef = useRef();
  const query = useQuery();
  const {
    featured,
    organizeBy,
    sort,
    customOrderJR,
    customOrderCAT,
    jobRole,
    category,
    isRequesting,
    milestones,
    featuredMilestone,
    currentMilestones,
    pastMilestones,
    upcomingMilestones,
    pinnedMilestones,
    taggedMilestones,
    total: totalMilestones,
    limit: milestonesLimit,
    loadMore: loadMoreMilestones,
    refresh: refreshMilestones,
    initialize: initializeMilestones,
    milestonesSearchtext,
    dontFetch,
    setRefreshMilestones,
    getMilestones,
    finishGetMilestone,
    setFeaturedMilestone,
    setCurrentMilestones,
    setPastMilestones,
    setUpcomingMilestones,
    setMilestones,
    setIsFeatured,
    setOganizeBy,
    setSort,
    setCustomOrderJR,
    setCustomOrderCat,
    setJobRole,
    setCategory,
    setFilters,
    setClearFilters,
    addMilestones,
    updateMilestones,
    updateCurrentMilestone,
    updatePastMilestone,
    updateFeaturedMilestone,
    deleteMilestone,
    deleteMilestoneOrg,
    setPinMilestones,
    updatePinMilestones,
    updateUpcomingMilestones,
    setMilestonesSearchText,
    setResetPinned,
    updateTaggedMilestones,
    setTaggedMilestones,
  setLoadingTranslator,
  setButtonCount
  } = useMilestones();
  const { setCategoryFilter } = useCategoryFilter();
  const { setPositionFilter } = usePositionFilter();
  const { subscription,setPremium,viewPremiumBar,closeAlertBar,setCloseBar,viewPremiumFooter,showPremiumPopUp } = useContext(SubscriptionContext);

  const fetchMilestonesId = useRef(0);

  useEffect(() => {
    if (!_.isEmpty(profile)) {
      getPinned()
    }
  }, [milestonesSearchtext]);

  useEffect(()=>{
    refreshResumes();
  },[profileId])

  const positionResolver = useRef(null);
  const positionPromise = useRef();

  if(!positionPromise.current) {
    positionPromise.current = new Promise(resolve => {
      positionResolver.current = resolve;
    });
  }
  const urlParams = new URLSearchParams(window.location.search);
  const isPublicView = urlParams.get("viewPublic");
  const showReel = urlParams.get("showreel"); // qr code from resume to view the photo/image tab
  const aboutSection = urlParams.get("aboutSection");
  const adminUpload = urlParams.get("admin");
  const [proInfo, setProInfo] = useState(false);
  const [showreel, setShowreel] = useState(null);
  const [viewPublic, setViewPublic] = useState(isPublicView === "true" || false);
  const parseJSON = (raw, fallback) => {
    if (raw === null || raw === '') return fallback;
    try { return JSON.parse(raw); } catch { return fallback; }
  };
  const milestoneFilterParam = {
    jobRole:        parseJSON(urlParams.get('jr'),    []),
    sort:           urlParams.get('s')  ?? 'Custom Order',
    category:       parseJSON(urlParams.get('c'),     []),
    organizeBy:     urlParams.get('ob') ?? 'Job/Role',
    customOrderJR:  parseJSON(urlParams.get('cojr'),  []),
    arrange:        parseJSON(urlParams.get('ar'),    { success: true, value: 'Custom Order' }),
    featured:       urlParams.get('f') === '1',
    customOrderCAT: parseJSON(urlParams.get('cocat'), []),
  };
  const isShareMilestoneView = urlParams.get('share-milestones-view') === 'true';

  // Keep the front-page showreel (shown above the milestones feed) in sync when
  // videos are edited/deleted in the Photos & Videos tab, so it updates without
  // a page refresh. The edited video list carries the is_front_page_showreel flag.
  const handleVideosShowreelSync = (videos = []) => {
    const front = (videos || []).find((v) => v?.is_front_page_showreel);
    setShowreel(front || null);
  };

  const [isYourProfile, setIsYourProfile] = useState(true); 

  useEffect(()=>{
    if(showReel === "true"){
      // The showreel QR opens the feature video as an auto-playing lightbox over
      // the MAIN profile page — it must NOT switch to the Photos & Videos tab.
      (async () => {
          try {
            const { data } = await http.get("public/user-galleries", {
              user_profile_id: profileId,
              type: "video",
              limit: 1,
              page: 1,
              qr_reels:1
            });
            const video = data?.data?.[0];
            setShowreel(video?.is_front_page_showreel ? video : null);
            if (video?.link) {
              watchMediaModal({ title:'Showreels', url:video.link, orientation:video.orientation }, () => {});
            }
          } catch (e) {
            console.error("error@fetchShowreel", e);
            setShowreel(null);
          }
        })();
    }
  },[showReel]);
  useEffect(()=>{
    if(aboutSection === "true")
    setSelectedTab('about')
  },[aboutSection]);

  useEffect(()=>{
    if(adminUpload === "upload" && ownerProfile()){
      uploadMilestone({profile_id:profileId},
        (callBack) => {
          console.log("showMoreSocial callback", callBack);
          if(callBack?.success){
            toast.success('Successfully uploaded');
          }
          const pathWithoutSearch = loc.pathname;
          history.replace(pathWithoutSearch);
          fetchMilestones();
        }
      );
    }
  },[adminUpload,profileId])

  useEffect(() => {
    if (userData) {
      let user_data = JSON.parse(localstorage.get("user_data").value); 
      if (!user_data?.profiles) return; // fixed after login error
      let intervalId;
      let index = user_data?.profiles?.findIndex((p) => p?.id == profileId);
      if(index !== -1){
        user_data.profile = user_data?.profiles[index];
        // localstorage.set("user_data", JSON.stringify(user_data));
        if(profile){
           localStorage.setItem('lang', profile?.lang || 'en');
            i18n.changeLanguage(profile?.lang)
        }
        if(viewPublic) setIsYourProfile(false);
        else setIsYourProfile(true);
        announcementLogged();
        fetchAnnouncements();

        intervalId = setInterval(() => {
        fetchAnnouncements(); 
      }, 600000);
 
      } else {  
        setIsYourProfile(false);
        if(selectedTab !== 'milestones') setSelectedTab('milestones')
      }
      return () => {
        if (intervalId) clearInterval(intervalId);
      };
    } else {
      setIsYourProfile(false);
      if(selectedTab !== 'milestones') setSelectedTab('milestones')
    }

  }, [profile]);

  const isGif = /\.gif($|\?)/i.test(profile?.profile_image_url ?? "");

  const isWithProInfo = useMemo(() => proInfo, [proInfo]);
  const fetchProInfo = async () => {
    if (isYourProfile) {
        setProInfo(null);
        return;
    }
    try {
        const { data } = await http.get(`public/professional-informations`, {
            user_profile_id: profile.id,
        });

        const hasValue = Object.entries(data).some(([key, value]) => {
          // Exclude these keys
          const excludedKeys = ['id', 'user_profile_id', 'created_at', 'updated_at'];
          return !excludedKeys.includes(key) && value !== null;
          });
          setProInfo(hasValue)
          if((profile?.occupations) ? profile?.occupations.length > 0 : false){
            setProInfo(true);
          } 
    } catch (error) {
        console.error('Error fetching professional information:', error);
        setProInfo(false); // Handle errors gracefully
    }
};
  /**
   * This function excecutes when
   * the user click the fab button
   */
  const scrollTop = () => {
    contentRef.current.scrollTo(0, 0);
  };
  const handleSendMessage = () => {
    sendModal(
      {
        userData,
        profile,
      },
      (result) => {
        console.log("result =>", result);
      }
    );
  };
  const addMilestone = () => {
    optionListRef?.current?.close();
    modalAdd(
      {
        userData,
        profile,
      },
      (callback) => {
        if (callback && callback.success) {
          if(organizeBy === JOB_ROLE || organizeBy === CATEGORY){
            const _total = parseInt(totalMilestones) + 1
            setMilestones({data:callback.data.data, total:_total})
          }else{
            addMilestones(callback.data);
          }
          getPositions();
          getCategory();
        } else if (callback === "upgrade") {
          history.push("/plans");
        }
      }
    );
  };
  const addQuickMilestone = ()=>{
      optionListRef?.current?.close();
      quickAddMile(
        {
          userData,
          profile,
        },
        (callback) => {
          if (callback && callback?.success) {
            addMilestones(callback.data);
            getPositions();
            getCategory(); 
          }if(callback?.dontShowTut){
              setProfile((prev)=>(
                {...prev,
                  onboarding:{
                    ...prev.onboarding,
                    milestone_create:true
                  }
                }
              ))
            }
          else if (callback === "upgrade") {
            history.push("/plans");
          }
        }
      );
    }
  const switchProfile = () => {
    setSwitchingProfile(true);
    // uncomment below to show  switchProfileModalw
    // switchProfileModal({ userData }, (result) => {
    //   console.log("result =>", result);
    // });
  };
  const handleWatch = (title, url,orientation="Landscpae", tiktok = false, header="") => {
    watchMediaModal({ title, url, tiktok,header,orientation }, (result) => {
      console.log("result =>", result);
    });
  };
  const handleImageGallery = (title, button, media) => {
    imageGalleryModal({ title, button, media }, (result) => {
      console.log("result =>", result);
    });
  };
  const handleViewPdf = (title, url,media, allData) => {
    let medMeta = media[0] || {}
    pdfViewerModal({ title, url,medMeta, allData }, (result) => {
      console.log("result =>", result);
    });
  };
  const editMilestone = (milestone, section) => {
    modalEdit({ userData, profile, milestone }, (callback) => {
      //
      history.push(`${history.location.pathname}`);
      //
      if(callback?.dontShowTut){
        let newProfile = {
          ...profile,
          onboarding:{
            ...profile.onboarding,
            milestone_edit:true
          }
        }
        setProfile(newProfile)
      }
      updateMilestonesState(callback,section);
    });
  };

  const updateMilestonesState = (callback,section)=>{
      if (callback && callback.success) {
        if (organizeBy === "Date" || _.isEmpty(organizeBy)) {
          // feature
          if (featured) updateFeaturedMilestone(callback);

          if (section === "current") {
            updateCurrentMilestone(callback);
          }else if(section === "upcoming"){
            // const changes = Array.isArray(callback.data) ? callback.data : [callback.data];
            updateUpcomingMilestones(callback)
          } else if (section === "past") {
            updatePastMilestone(callback);
          } else if (section === "pin"){
            const changes = Array.isArray(callback.data) ? callback.data : [callback.data];
            updatePinMilestones({ data: changes });
          }
          else {
            updateCurrentMilestone(callback);
            updatePastMilestone(callback);
          }
        } else {
          if (featured) updateFeaturedMilestone(callback);

          if (section === "current") {
            updateCurrentMilestone(callback);
          } else if(section === "upcoming"){
            // const changes = Array.isArray(callback.data) ? callback.data : [callback.data];
            updateUpcomingMilestones(callback)
          } else if (section === "past") {
            updatePastMilestone(callback);
          } else if (section === "pin"){
            const changes = Array.isArray(callback.data) ? callback.data : [callback.data];
            updatePinMilestones({ data: changes });
          } else {
            updateMilestones(callback);
          }

        }
        // getPositions();
      } else if (callback === "upgrade") {
        history.push("/plans");
      }
  }
  const removeMilestone = (milestone, isDemo=false) => {
    modalDelete({ userData, milestone,isDemo }, (callback) => {
      //
      history.push(`${history.location.pathname}`);
      //
      if (callback && !isDemo) {
        if(organizeBy === JOB_ROLE || organizeBy === CATEGORY){
          deleteMilestoneOrg(milestone)
        }else{
          deleteMilestone(milestone);
        }
        getPositions();
      }
    });
  };

  const togglePrivacyTaggedMilestone = (milestone) => {
    updateTaggedMilestones(milestone);
  }

  // Tags awaiting the owner's decision (Newly Tagged Milestones). Decided tags
  // live in redux `taggedMilestones`; pending ones are kept locally here.
  const [pendingTagged, setPendingTagged] = useState([]);

  /**
   * Actually removes a tagged milestone from the logged-in user's own tagged
   * list (self-removal). The milestone belongs to someone else but tags this
   * profile; the backend soft-deletes the tag, so we pass the logged-in user's
   * own profile id. Updates both the pending and decided lists.
   */
  const doRemoveTag = async (milestone) => {
    if (!milestone || !userData) return;
    let user_data = {};
    try {
      const raw = localStorage.getItem("user_data");
      if (raw) user_data = JSON.parse(raw);
    } catch (e) {
      user_data = {};
    }
    const myProfileId = user_data?.profile?.id;
    // only allow self-removal on the viewer's own tagged list
    if (!myProfileId || Number(myProfileId) !== Number(profileId)) return;
    try {
      const { data } = await http.delete(
        `public/milestone-tag/${milestone.id}/${myProfileId}`
      );
      if (data?.success) {
        setPendingTagged((prev) => prev.filter((m) => m.id !== milestone.id));
        const remaining = taggedMilestones.filter((m) => m.id !== milestone.id);
        setTaggedMilestones({ data: remaining, total: remaining.length });
        toast.success(t("removedFromTaggedList", "Removed from your tagged list"));
      }
    } catch (e) {
      console.error("error@onRemoveTag", e);
      toast.error(t("somethingWentWrong"));
    }
  };

  // Delete (on a pending card) and "Remove from my page" (on a decided card)
  // both confirm first — the tag leaves your page but stays on the tagger's.
  const confirmRemoveTag = (milestone) => {
    const taggerName = milestone?.profile?.profile_name || "";
    modalRemoveTag({ taggerName, onConfirm: () => doRemoveTag(milestone) }, () => {});
  };
  const onRemoveTag = confirmRemoveTag;

  /**
   * Decide a pending tag (Make Public / Make Private). Sets the tag's visibility
   * for this profile only (no effect on the original milestone) and moves it out
   * of Newly Tagged and into the decided Tagged list.
   */
  const decideTaggedMilestone = async (milestone, isPrivate) => {
    if (!milestone || !userData) return;
    const myProfileId = userData?.profile?.id;
    if (!myProfileId) return;
    try {
      const { data } = await http.put(
        `public/milestone-tag/${milestone.id}/${myProfileId}/decision`,
        { is_private: isPrivate }
      );
      if (data?.success) {
        setPendingTagged((prev) => prev.filter((m) => m.id !== milestone.id));
        const decided = {
          ...milestone,
          is_private: isPrivate,
          privacy: isPrivate ? "Private" : "Public",
          tag_status: "decided",
        };
        const exists = taggedMilestones.some((m) => m.id === milestone.id);
        const nextTagged = exists
          ? taggedMilestones.map((m) => (m.id === milestone.id ? decided : m))
          : [decided, ...taggedMilestones];
        setTaggedMilestones({ data: nextTagged, total: nextTagged.length });
        toast.success(
          isPrivate ? t("setToPrivate", "Set to private") : t("setToPublic", "Set to public")
        );
      }
    } catch (e) {
      toast.error(t("somethingWentWrong"));
    }
  };

  const viewAnalytics = (milestone) => {
    history.push(`/settings?milestone_id=${milestone?.id}`);
  };

  const copyLink = (milestone) => {
    const url = `${process.env.REACT_APP_PUBLIC_DOMAIN}${history.location.pathname}?milestone=${milestone?.hash_id}`;
    navigator.clipboard.writeText(url).then(() => {
      toast.success(t('linkCopied'));
    });
  };

  const milestoneEmbed = (milestone) => {
    // const embedUrl = `${process.env.REACT_APP_PUBLIC_DOMAIN}/embed/milestone/${milestone?.hash_id}`;
    // const iframeCode = `<iframe src="${embedUrl}" width="1200" height="300" frameborder="1"></iframe>`;
    const srcWidget = `${window.location.origin}/widget.js`
    const cleanUrl = API_ENDPOINT.replace(/\/$/, "");
    const iframeCode = `
    <div id="widget-container">
      <script
        src=${srcWidget}
        data-id=${milestone?.hash_id}
        data-api=${cleanUrl}
        data-siteUrl=${window.location.origin}
        data-copy=${`${process.env.REACT_APP_PUBLIC_DOMAIN}${history.location.pathname}`}
      ></script>
    </div>
    `;
    navigator.clipboard.writeText(iframeCode).then(() => {
      toast.success('Copied Embed Milestone');
    });
  };

  const translateMilestone = async(milestone, section, lang='en') => {
    try{
      let curLang = localStorage.getItem('lang');
    if (!_.isEmpty(userData?.profile)) {
        try {
        setLoadingTranslator(true);
         const { data } =  await http.put(`public/milestone/${milestone?.id}/translate`, {
            lang: curLang,
            organize_by: organizeBy,
            order:milestone.order // useful for pinned milestone to avoid the re-organize
          });
          if(data.data){
            updateMilestonesState({ success: true, data: data.data }, section);
            toast.success(t('completedTranslate'))
          }else{
            toast.success(t('beenTranslated'));
          }
        } catch (err) {
          console.error("error@translation", err);
          toast.error(t('somethingWentWrong'));
          throw err;
        }
      }
    }catch(e){
      console.error(e); 
    }finally{
        setLoadingTranslator(false);
    }
  }

  const reportMilestone = (milestone = {}, accountReport = {}, type) => {
    modalReport({ userData, milestone, accountReport, type }, (callback) => {
      if (callback && callback.success) {
        if (type === "profile") {
          setProfile(callback.data);
        }
      }
    });
  };

  const handleUpdateTranslate = (newProfile={}, socMed=[]) => {
      setProfile(newProfile);
      setSocMed(socMed);
  };

  const checkDomain = () => {
    const currentDomain = window.location.hostname;
    // hide in production 
    if (currentDomain.includes('app.milestonespage.com') || API_ENDPOINT.includes('app.milestonespage.com')) {
      return false;
    } else {
      return true;
    }
  };
  /**
   * This method will fetch
   * position filter options
   */
  const getPositions = async () => {
    try {
      let privacy = ["public"];
      if (userData) {
        const isOwner = profile.user && userData?.user && userData.user.id === profile.user.id;
        if (isOwner) {
          privacy.push("private", "verified", "unlisted");
        } else if (userData?.account_verified && !_.isEmpty(userData.account_verified)) {
          privacy.push("verified");
        } else if (!_.isEmpty(permission)) {
          privacy.push("unlisted");
        }
      }
      const localLang = currentLang();
      const { data } = await http.get("public/positions/filter", {
        user_profile_id: profile.id,
        privacy
      },{},true);
      const positions = data.map((position) => ({
        ...position,
        label: position[localLang] || position.name,
        value: position.id,
        count: position.milestone_position_count,
      }));
      setOptions((prev) => ({
        ...prev,
        positions,
      }));

      if (
        userData &&
        userData?.profile &&
        profile &&
        userData?.profile.id === profile.id
      ) {
        setPositionFilter(positions);
      }

      if(typeof positionResolver.current === 'function') {
        positionResolver.current(positions);
      }
    } catch (err) {
      console.log("error@getPositions", err);
      throw err;
    }
  };
  /**
   * This method will fetch
   * category filter options
   */
  const getCategory = async () => {
    try {
      let privacy = ["public"];
      if (userData) {
      if (
        profile.user &&
        userData?.user &&
        userData?.user.id === profile.user.id
      ) {
        privacy.push("private");
        privacy.push("verified");
        privacy.push("unlisted");
      } else {
        if (
          userData?.account_verified &&
          !_.isEmpty(userData?.account_verified)
        ) {
          privacy.push("verified");
        } else if (!_.isEmpty(permission)) {
          privacy.push("unlisted");
        }
      }
    }
      // const url = urlSerializer("public/categories/filter", {
      //   user_profile_id: profile.id,
      // });
      const { data } = await http.get("public/categories/filter", {
        user_profile_id: profile.id,
        privacy:privacy
      },{},true);
      const localLang = currentLang()
      const categories = data.map((category) => ({
        ...category,
        label: category[localLang] || category.name,
        value: category.id,
        count: category.milestones_count,
        id: category.id
      }));
      setOptions((prev) => ({
        ...prev,
        categories,
      }));

      if (
        userData &&
        userData?.profile &&
        profile &&
        userData?.profile.id === profile.id
      ) {
        setCategoryFilter(categories || []);
      }
    } catch (err) {
      console.log("getPosition", err);
    }
  };
  const ownerProfile = ()=>{
    let user_data = {};
      try {
        const raw = localStorage.getItem("user_data"); // standard API
        if (raw) {
          user_data = JSON.parse(raw);
        }
      } catch (e) {
        console.warn("Failed to parse user_data from localStorage:", e);
        user_data = {};
      }
    let ownProfile = Number(profileId) === Number(user_data?.profile?.id ?? -1);

    return ownProfile;
  }
  /**
   * This method will fetch
   * milestone list view data
   */
  const fetchMilestones = async (forceViewPublic=false, user_profile_id=null, tutorial_id=null) => {
    let privacy = ["public"];
    let upcoming = [];
    let current = [];
    let past = [];
    let pin = [];
    let loadMore = false;
    
    if(adminUpload === "upload" && ownerProfile()) return; //dont fetch yet for the milestones upload from doc
    if(isYourProfile && profile.onboarding && Boolean(profile.onboarding?.get_started) === false && profile?.profile_type?.type === "personal") return; //skip for new users to fetch milestone
    if (isRequesting || dontFetch) return; //to avoid fetching the milestone when no data any more and avoid too many request.

    await getMilestones();

    if (userData && !viewPublic && !forceViewPublic) {
      if (
        profile.user &&
        userData?.user &&
        userData?.user.id === profile.user.id
      ) {
        privacy.push("private");
        privacy.push("verified");
        privacy.push("unlisted");
      } else {
        if (
          userData?.account_verified &&
          !_.isEmpty(userData?.account_verified)
        ) {
          privacy.push("verified");
        } else if (!_.isEmpty(permission)) {
          privacy.push("unlisted");
        }
      }
    }
    try {
      const roles = jobRole.map((p) => p.name || p.label);
      const categories = category.map((p) => p.name || p.label);
      const requestId = ++fetchMilestonesId.current;
      const { data } = await http.get("public/milestones/list-view", {
        featured,
        organize_by: organizeBy,
        category: categories,
        skip: totalMilestones,
        job_role: roles,
        user_profile_id: user_profile_id || profile.id,
        limit: milestonesLimit,
        privacy,
        sort,
        customOrderJR,
        customOrderCAT,
        ...(milestonesSearchtext && {
          search: milestonesSearchtext
        })
      },
      { headers: {} },
      true
    ); 

      if (requestId !== fetchMilestonesId.current) {
        console.log("Ignoring outdated response");
        return;
      }
      if(isYourProfile && Boolean(profile.onboarding?.milestone) === false && tutorial_id){
            setTutMile(tutorial_id);
      }


      loadMore = data.total > 0 ? true : false;
      const _total = parseInt(totalMilestones) + data.total;
      
      if (sort === DATE_NEWEST_TO_OLDEST || _.isEmpty(sort)) { 
        data.data.forEach((m) => {
          if (compareDate(m) === 'upcoming') {
              upcoming.push(m);
              return;
          } else if (compareDate(m) === 'current') {
              current.push(m);
              return
          } else if (compareDate(m) === 'past') {
            past.push(m);
            return
          }
        });
        // pin = sortNoteLatest(data.pinned);
        // setPinMilestones({ data: pin, total: _total }) 
        current = sortNoteLatest(current);
        upcoming = sortNoteLatest(upcoming);
        past = sortNoteLatest(past); 
       
        setCurrentMilestones({ data: current, total: _total });
        setPastMilestones({ data: past, total: _total });
        setUpcomingMilestones({ data: upcoming, total: _total });
      }
      // else if(organizeBy === DATE_NEWEST_TO_OLDEST){
      //   data.data.forEach((m) => {
      //     current.push(m);
      //   });
      //   current.sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
      //   setCurrentMilestones({ data: current, total: _total });
      // }
      else if(sort === DATE_OLDEST_TO_NEWEST){
        data.data.forEach((m) => {
          if (compareDate(m) === 'upcoming') {
              upcoming.push(m);
              return;
          } else if (compareDate(m) === 'current') {
              current.push(m);
              return
          } else if (compareDate(m) === 'past') {
            past.push(m);
            return
          }
        });  
        current = sortOldest(current);
        upcoming = sortOldest(upcoming);
        past = sortOldest(past);
        // pin = sortOldest(data.pinned);
        // setPinMilestones({ data: pin, total: _total })
        setPastMilestones({ data: past, total: _total });
        setUpcomingMilestones({ data: upcoming, total: _total });
        setCurrentMilestones({ data: current, total: _total });
      } else {
        setMilestones({ data: data.data, total: _total });
        pin = sortNoteLatest(data?.pinned || []);
        setPinMilestones({ data: pin, total: _total }) 
      }
    } catch (err) {
      console.log("error@fetchMilestones", err);
    } finally {
      await finishGetMilestone({
        loadMore: loadMore,
      });
    }
  };
  

  const viewReportMilestone = async () => {
    console.log("=============START===================");
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    if (code) {
      try {
        const { data } = await http.get(`public/viewReports/${code}`);
        // setReportDetails({ milestone: data, open: true });
        onView(data);
      } catch (e) {
        // setReportDetails({ milestone: {}, open: false });
        console.error(e);
      }
    }
    console.log("=============END===================");
  };

  const onView = (milestone) => {
    modalViewMilestone(
      {
        data: milestone,
        onWatchMedia: handleWatch,
        onViewImage: handleImageGallery,
        onEdit: editMilestone,
        onDelete: removeMilestone,
        isYourProfile: isYourProfile,
        profile: userData?.profile,
      },
      (cb) => {
        // callback
      }
    );
  };

  /**
   * This method will clear the list view filters
   */
  const clearFilters = async() => {
    localstorage.remove("filter.jobRole");
    localstorage.remove("filter.sort");
    localstorage.remove("filter.category");
    localstorage.remove("filter.featured"); 
    localstorage.remove("filter.arrange");
    localstorage.remove("filter.customOrderJR");
    localstorage.remove("filter.customOrderCAT");
    localstorage.remove("filter.organizeBy");
    setClearFilters();
     if (
      userData &&
      userData?.profile &&
      !_.isEmpty(profile) &&
      userData?.profile.id === profile.id
    ){
      let user_data = JSON.parse(localStorage.getItem("user_data")); 
      user_data.profile = {...user_data?.profile, milestone_filter:null}
      localstorage.set("user_data", JSON.stringify(user_data));
      try {
        http.post(
          `public/profiles/${userData?.profile.id}/clear-filter`
        ); 
        setProfile({...profile, milestone_filter:null})
      }catch(e){
        console.error(e);
      }
    }else{
      setProfile({...profile, milestone_filter:null})
    }
   
  };
  /**
   * This method will fetch
   * featured milestone
   */
  const getFeaturedMilestone = async () => {
    try {
      const { data } = await http.get("public/milestones/featured", {
        organize_by: organizeBy,
        job_role: jobRole,
        category: category,
        user_profile_id: profile.id,
      });

      if (!_.isEmpty(data)) {
        setFeaturedMilestone(data);
      } else {
        setFeaturedMilestone({});
      }
    } catch (err) {
      console.log("error@getFeaturedMilestone", err);
      throw err;
    }
  };
  /**
   * This method will fetch
   * featured milestone
   */
  const getPinned = async (forceViewPublic = null) => {
    // if (!userData || _.isEmpty(profile)) {
    //   return;
    // }

    try {      
      let privacy = null;
      const isPublic = forceViewPublic !== null && forceViewPublic !== undefined
        ? forceViewPublic
        : viewPublic;
      if ((isPublic || _.isEmpty(userData))) {
        privacy = ["public"];
      }
      // if (userData) {
      //   const isOwner = profile.user && userData?.user && userData.user.id === profile.user.id;
      //   if (isOwner) {
      //     privacy.push("private", "verified", "unlisted");
      //   } else if (userData?.account_verified && !_.isEmpty(userData.account_verified)) {
      //     privacy.push("verified");
      //   } else if (!_.isEmpty(permission)) {
      //     privacy.push("unlisted");
      //   }
      // }
      setResetPinned()
      const url = urlSerializer("public/milestones/pinned-view", {
        organize_by: organizeBy,
        ...(privacy != null && { privacy }),
        user_profile_id: profileId,
        ...(milestonesSearchtext && {
          search: milestonesSearchtext
        })
      });
      const { data } = await http.get(url);
        setPinMilestones({ data: data.pinned, total: 0 }) 
    } catch (err) {
      if ((err.status === 401  || err.status === 404) && err?.data?.message === "Unauthorize for adult content" && userData == null) {
        setShowNoProfileFound(true);
      console.log("::error@getUserProfile", err);console.log("error@getUserProfile", err);
    }
  };
  }
  const getTagged = async () => {
    try {      
      const uname = username.split("-")[0];
      const { data } = await http.get("public/milestones/tagged-view", {
        username: uname,
        profile_id: profileId,
      });
      console.log("data.tagged: ", data);
        setTaggedMilestones({ data: data.tagged, total: data.tagged.length })
        setPendingTagged(Array.isArray(data.pending) ? data.pending : [])
    } catch (err) {
      if ((err.status === 401  || err.status === 404) && err?.data?.message === "Unauthorize for adult content" && userData == null) {
        setShowNoProfileFound(true);
      console.log("::error@getUserProfile", err);console.log("error@getUserProfile", err);
    }
  };
  }
  const getUserProfile = async (uname) => {
    try {    
      // refreshResumes();
      setFetchSocMed({social_media:[], follow:null})
      await getPinned();
      const url = urlSerializer("public/user-profiles/get-profile", {
        username: uname,
        id: profileId,
      });
      const { data } = await http.get(url);
      setProfile(data);
      setMilestoneFilters(data);
      setSwitchingProfile(false); 
      let user_data = {};
      try {
        const raw = localStorage.getItem("user_data"); // standard API
        if (raw) {
          user_data = JSON.parse(raw);
        }
      } catch (e) {
        console.warn("Failed to parse user_data from localStorage:", e);
        user_data = {};
      }
      let ownProfile = Number(profileId) === Number(user_data?.profile?.id ?? -1);
      if(ownProfile && data?.onboarding && Boolean(data?.onboarding?.get_started) === false && (data?.profile_type?.type === "personal")){
        modalGetStarted({profile:data,userData},
          (callback) => {  
          if (callback.success) {
            let user_data = null;
            try {
              user_data = JSON.parse(localStorage.getItem("user_data"));
            } catch (e) {
              console.error("Invalid user_data in localStorage:", e);
              user_data = {};
            }
            if (user_data) {
              user_data.profile = {
                ...user_data.profile,
                ...callback.data
              };
              setUserData(user_data);
              localStorage.setItem("user_data", JSON.stringify(user_data));
            }
            const updatedProfile = {
              ...data,
              ...callback.data,
            };
            setProfile(updatedProfile);
            fetchMilestones(false,updatedProfile?.id,callback.milestone_id);
          }

        }
        );
      }else{
        setOnboarding(false)
      }

      const { data: result } = await http.get("public/social-medias", {
          user_profile_id: data?.id,
          user_id: data?.user_id
      });
      setFetchSocMed(result)
    } catch (err) {
      if ((err.status === 401  || err.status === 404) && err?.data?.message === "Unauthorize for adult content" && userData == null) {
        setShowNoProfileFound(true);
      }
      setShowNoProfileFound(true);
      console.log("::error@getUserProfile", err);console.log("error@getUserProfile", err);
    }
  };
  const setMilestoneFilters = async (profile) => {
    if(!!profile.milestone_filter || isShareMilestoneView){/**set local storage for not null milestone filter because the local storage is not changing from initial load */
      let key_filter = profile?.milestone_filter;
      if(isShareMilestoneView){
         key_filter = milestoneFilterParam;
      }
      console.log(key_filter)
      if(key_filter?.organizeBy === CATEGORY){
        localstorage.set("filter.customOrderCAT", JSON.stringify(key_filter?.customOrderCAT) ?? []);
      }if(key_filter?.organizeBy === JOB_ROLE){
        localstorage.set("filter.customOrderJR", JSON.stringify(key_filter?.customOrderJR) ?? []);
      }if(key_filter?.category){
        localstorage.set("filter.category", JSON.stringify(key_filter?.category) ?? []);
      }if(key_filter?.jobRole){
        localstorage.set("filter.jobRole", JSON.stringify(key_filter?.jobRole) ?? []);
      }if(key_filter?.organizeBy){
        localstorage.set("filter.organizeBy", key_filter?.organizeBy); 
      }if(key_filter?.sort){
        localstorage.set("filter.sort", key_filter?.sort);
      }
    }
    else{
      localstorage.remove("filter.jobRole");
      localstorage.remove("filter.sort");
      localstorage.remove("filter.category");
      localstorage.remove("filter.featured"); 
      localstorage.remove("filter.arrange");
      localstorage.remove("filter.customOrderJR");
      localstorage.remove("filter.customOrderCAT");
      localstorage.remove("filter.organizeBy");
    }

    const filterJobRole = localstorage.get("filter.jobRole");
    const filterSort = localstorage.get("filter.sort");
    const filterOrganizeBy = localstorage.get("filter.organizeBy");
    const filterArrange = localstorage.get("filter.arrange");
    const customOrderJR = localstorage.get("filter.customOrderJR");
    const filterCustomOrderCat = localstorage.get("filter.customOrderCAT");
    const filterCategory = localstorage.get("filter.category");
    const filterFeatured = localstorage.get("filter.featured"); 
    let milestone_filter = profile.milestone_filter;
    let filter = {};
    if (
      // userData &&
      // userData?.profile &&
      !_.isEmpty(profile)
      // userData?.profile.id === profile.id
    ) {
        if(filterJobRole.success) {
          
          if (
            filterJobRole.value.includes("[") &&
            filterJobRole.value.includes("]")
          ) {
            const roles = JSON.parse(filterJobRole.value).map((d) => d.label);
            setFilterRoles(roles);
            filter.job_role = JSON.parse(filterJobRole.value);
          } else {
            filter.job_role = filterJobRole.value ? [filterJobRole.value] : [];
          }
          
       } else {
    
        if (milestone_filter) {
            if (milestone_filter.job_role) {
              if(typeof milestone_filter.job_role === 'string') {
          
                filter.job_role = options.positions.filter(item => item.label === milestone_filter.job_role);
                /**
                 * sometimes options.position will be an empty array.
                 * so the code below will wait for the getPositions function to finish
                 * and get the return value of it and use that as the new option to be used
                 * in the array.filter function.
                 */
                if(options.positions.length === 0) {
                 
                  if(positionPromise.current instanceof Promise) {
                    const _options = await positionPromise.current;
                    filter.job_role = _options.filter(item => item.label === milestone_filter.job_role);
                  }
                }
              } 
      
              if(Array.isArray(milestone_filter.job_role)) {
                filter.job_role = milestone_filter.job_role;
              }
            }
          
            if (milestone_filter.category)
              filter.category = milestone_filter.category;
            if (milestone_filter.show_featured)
              filter.featured = milestone_filter.show_featured;
          }
      }

      if(filterOrganizeBy.success) {
        filter.organizeBy = filterOrganizeBy.value;
      } else {
        if(milestone_filter) {
          if (milestone_filter.organizeBy) filter.organizeBy = milestone_filter.organizeBy;
        }
      }

      if(filterSort.success) {
        filter.sort = filterSort.value;
      } else {
        if(milestone_filter) {
          if (milestone_filter.sort) filter.sort = milestone_filter.sort;
        }
      }
  
      if(filterCategory.success) {
        // filter.category = filterCategory.value; 
        if (
          filterCategory.value.includes("[") &&
          filterCategory.value.includes("]")
        ) {
          const cats = JSON.parse(filterCategory.value).map((d) => d.label);
          setFilterCategories(cats);
          filter.category = JSON.parse(filterCategory.value);
        } else {
          filter.category = filterCategory.value ? [filterCategory.value] : [];
        }
      } else {
        if(milestone_filter) {
          if (milestone_filter.category)
            filter.category = milestone_filter.category;
        }
      }
  
      if(filterFeatured.success) {
        filter.featured = JSON.parse(filterFeatured.value);
      } else {
        if(milestone_filter) {
          if (milestone_filter.show_featured)
            filter.featured = milestone_filter.show_featured;
        }
      }
 
        if(milestone_filter) {
          if (milestone_filter?.organizeBy)
            filter.organizeBy = milestone_filter.organizeBy;
        } 
      if(customOrderJR.success) {
          filter.customOrderJR = customOrderJR.value ? JSON.parse(customOrderJR.value) : [];   
        } else {
          if (milestone_filter?.customOrderJR){
            filter.customOrderJR = milestone_filter?.customOrderJR;
          }else{
            filter.customOrderJR = []
          }
        }
      if(filterCustomOrderCat?.success) {
        filter.filterCustomOrderCat = filterCustomOrderCat?.value ? JSON.parse(filterCustomOrderCat?.value) : [];
      } else {
          if (milestone_filter?.customOrderCAT){
            filter.filterCustomOrderCat = milestone_filter?.customOrderCAT;
          }else{
            filter.filterCustomOrderCat = [];
          }
        } 
      }
    
  

    setFilters({
      featured: filter?.featured || false,
      jobRole: filter?.job_role || [],
      organizeBy: filter?.organizeBy || null,
      category: filter?.category || [],
      sort: filter.sort || null,
      customOrderJR: filter.customOrderJR || [],
      customOrderCAT: filter.filterCustomOrderCat || []
    });
    setTimeout(() => {
      setRefreshMilestones();
    }, 300);
  };
  /**
   * This method will fetch
   * featured milestone
   */
  const getUserProfilePermission = async (uname) => {
    try {
      const url = urlSerializer(`public/user-accesses/permission`, {
        username: uname,
        user_id: userData?.user.id,
        profile_id: profileId,
      });
      const { data } = await http.get(url);
      if (!_.isEmpty(data)) {
        setPermission(data);
      }
    } catch (err) {
      console.log("error@getUserProfilePermission", err);
    }
  };
  const onChangeJobRole = (e) => {
    if (
      userData &&
      userData?.profile &&
      !_.isEmpty(profile) &&
      profile.id === userData?.profile.id
    ) {
      if (e.length > 0) {
        localstorage.set("filter.jobRole", JSON.stringify(e));
      } else {
        localstorage.remove("filter.jobRole");
      }
    }
    setJobRole(e);
  };

  const onChangeCategory = (e) => {
    if (
      userData &&
      userData?.profile &&
      !_.isEmpty(profile) &&
      profile.id === userData?.profile.id
    ) {
      if (e.length > 0) {
        localstorage.set("filter.category", JSON.stringify(e));
      } else {
        localstorage.remove("filter.category");
      }
    }
    setCategory(e);
  };

  const onChangeOrganizeBy = (e, sort={}, customOrder=[]) => {
    if (
      userData &&
      userData?.profile &&
      !_.isEmpty(profile) &&
      profile.id === userData?.profile.id
    ) {
      if (!e.label) {
        localstorage.remove("filter.sort");
        localstorage.remove("filter.arrange");
      } else {
        localstorage.set("filter.sort", sort.value);
        localstorage.set("filter.arrange", sort?.value || null);
        localstorage.set("filter.organizeBy", e.label);
        if(e.label === CATEGORY){
          localstorage.set("filter.customOrderCAT", JSON.stringify(customOrder) || null);
        }else{
          localstorage.set("filter.customOrderJR", JSON.stringify(customOrder) || null);
        }
      }
    }
    setOganizeBy(e.label);
    setSort(sort.value);
    setCustomOrderJR(customOrder);
    setCustomOrderCat(customOrder);
  };

  const onChangeFeaturedOnly = (e) => {
    if (
      userData &&
      userData?.profile &&
      !_.isEmpty(profile) &&
      profile.id === userData?.profile.id
    ) {
      localstorage.set("filter.featured", JSON.stringify(e.target.checked));
    }
    setIsFeatured(e.target.checked);
  };
  /* Add views on the user's profile if they are not the owner */
  const addProfileView = async () => {
    setRoute({ ...route, previousProfileVisit: route.to });

    updateMetaData({
      id: profile?.id,
      name: '',
      description: profile?.bio,
      imageUrl: profile?.cover_image_webp_url,
      url: `${process.env.REACT_APP_PUBLIC_DOMAIN}/share/${profile.user.username}/profile/${profile.id}`,
      title: profile?.profile_name
    });

    if (route.to !== route.from && route.previousProfileVisit !== route.to) {
      if (userData?.profile?.id !== profile?.id) {
        try {
          await http.post("public/profile-views", {
            user_profile_id: profile.id,
            viewer_profile_id: userData?.profile.id,
          });
        } catch (err) {
          console.log("error@addViewsToProfile", err);
          throw err;
        }
      }
    } else {
      console.log("Not adding profile view: Refreshed on the same profile");
    }
  };

  const getFollowing = async (type = "following") => {
    try {
      const { data } = await http.get("public/user-followers", {
        user_profile_id: profile?.id,
        type: type,
      });
      // if (!_.isEmpty(data?.data)) {
        if (type === "following") {
          setFollowing(data?.data || []);
        } else if (type === "followers") {
          setFollowers(data?.data || []);
        }
      // }
    } catch (err) {
      console.log("error@getFollowing", err);
    }
  };

  /**
   * This method will render detailed list view
   */
  const renderDetailedListView = () => {
    if (organizeBy === JOB_ROLE || organizeBy === CATEGORY) {
      return (
        <OrganizePositionDetailedListView
          key={selectedTab}
          organizeBy={organizeBy}
          showFeatured={featured}
          featured={featuredMilestone}
          milestones={milestones}
          pin={pinnedMilestones}
          tagged={taggedMilestones}
          tagView={selectedTab === "tagged"}
          onRemoveTag={onRemoveTag}
          onWatchMedia={handleWatch}
          onViewImage={handleImageGallery}
          handleViewPdf={handleViewPdf}
          onEdit={editMilestone}
          onDelete={removeMilestone}
          onReport={reportMilestone}
          isYourProfile={isYourProfile}
          profile={userData?.profile}
          permission={permission}
          categories={options.categories}
          positions={options.positions}
          onShare={shareMilestone}
          milestone_owner={profile}
          translateMilestone={translateMilestone}
          onCopyLink={copyLink}
          milestoneEmbed={milestoneEmbed}
          userData={userData}
          updateMilestonesState={updateMilestonesState}
        />
      );
    }
    return (
      <DetailedViewMilestones
        key={selectedTab}
        setTutMile={setTutMile}
        showTutMilestone={showTutMilestone}
        showFeatured={featured}
        featured={featuredMilestone}
        current={currentMilestones}
        past={pastMilestones}
        pin={pinnedMilestones}
        tagged={taggedMilestones}
        tagView={false}
        upcoming={upcomingMilestones}
        onWatchMedia={handleWatch}
        onViewImage={handleImageGallery}
        handleViewPdf={handleViewPdf}
        togglePrivacyTaggedMilestone={togglePrivacyTaggedMilestone}
        onEdit={editMilestone}
        onDelete={removeMilestone}
        onReport={reportMilestone}
        isYourProfile={isYourProfile}
        profile={userData?.profile}
        permission={permission}
        onShare={shareMilestone}
        milestone_owner={profile}
        translateMilestone={translateMilestone}
        onAnalytics={viewAnalytics}
        onCopyLink={copyLink}
        milestoneEmbed={milestoneEmbed}
        userData={userData}
        updateMilestonesState={updateMilestonesState}
        detailedView={true}
        setOnboardingDone = {()=>setOnboarding(false)}
      />
    );
  };
  /**
   * This method will render list view
   */
  const renderListView = () => {
    if (organizeBy === JOB_ROLE || organizeBy === CATEGORY) {
      return (
        <OrganizePositionListView
          organizeBy = {organizeBy}
          showFeatured={featured}
          featured={featuredMilestone}
          milestones={milestones}
          pin={pinnedMilestones}
          tag={taggedMilestones}
          onWatchMedia={handleWatch}
          onViewImage={handleImageGallery}
          handleViewPdf={handleViewPdf}
          onEdit={editMilestone}
          onDelete={removeMilestone}
          onReport={reportMilestone}
          isYourProfile={isYourProfile}
          profile={userData?.profile}
          permission={permission}
          categories={options.categories}
          positions={options.positions}
          onShare={shareMilestone}
          milestone_owner={profile}
          translateMilestone={translateMilestone}
          onCopyLink={copyLink}
          milestoneEmbed={milestoneEmbed}
        />
      );
    }
    return (
      <ListViewMilestones
        showFeatured={featured}
        featured={featuredMilestone}
        current={currentMilestones}
        past={pastMilestones}
        pin={pinnedMilestones}
        upcoming={upcomingMilestones}
        onWatchMedia={handleWatch}
        onViewImage={handleImageGallery}
        handleViewPdf={handleViewPdf}
        onEdit={editMilestone}
        onDelete={removeMilestone}
        onReport={reportMilestone}
        isYourProfile={isYourProfile}
        permission={permission}
        onShare={shareMilestone}
        profile={userData?.profile}
        milestone_owner={profile}
        translateMilestone={translateMilestone}
        onCopyLink={copyLink}
        milestoneEmbed={milestoneEmbed}
      />
    );
  };
  /**
   * This method will render column view
   */
  const renderColumnView = () => {
    return (
      <ColumnViewMilestones
        selectedTab={selectedTab}
        organizeBy={organizeBy}
        showFeatured={featured}
        featured={featuredMilestone}
        current={currentMilestones}
        past={pastMilestones}
        pin={pinnedMilestones}
        upcoming={upcomingMilestones}
        milestones={milestones}
        onWatchMedia={handleWatch}
        onViewImage={handleImageGallery}
        handleViewPdf={handleViewPdf}
        onEdit={editMilestone}
        onDelete={removeMilestone}
        onReport={reportMilestone}
        isYourProfile={isYourProfile}
        permission={permission}
        options={options}
        setSelectedTab={setSelectedTab}
        onChangeOrganizeBy={onChangeOrganizeBy}
        onChangeFeaturedOnly={onChangeFeaturedOnly}
        filterRoles={filterRoles}
        userData={userData}
        profile={userData?.profile}
        onShare={shareMilestone}
        sort={sort}
        customOrderJR={customOrderJR}
        customOrderCAT={customOrderCAT}
        categories={options.categories}
        milestone_owner={profile}
        translateMilestone={translateMilestone}
        onCopyLink={copyLink}
        milestoneEmbed={milestoneEmbed}
      />
    );
  };


  const shareMilestone = (milestone, status="") => {

    const featuredDate = formatDate(featured, profile?.dateFormat,t);
    updateMetaData({
      id: milestone?.id,
      name: '',
      description: `${featuredDate} ${milestone?.date_note}`,
      imageUrl: milestone.thumbnail?.url,
      url: `${process.env.REACT_APP_PUBLIC_DOMAIN}/share${history.location.pathname}/${milestone.hash_id}`,
      title:milestone.title
    });
    setStatus(status);
    shareModal(
      {
        url: `${process.env.REACT_APP_PUBLIC_DOMAIN}/share${history.location.pathname}/${milestone.hash_id}`,
        image: profile.profile_image_url,
        title: milestone.title,
        description: milestone.description == 'null' || milestone.description == null ? "Milestones Page - Your Creative History In One Place" : milestone.description,
      },
      (callBack) => {
        console.log("showMoreSocial callback", callBack);
      }
    );
    // history.push(`${history.location.pathname}?milestone=${milestone.hash_id}`);
  };

   const announcementLogged = () => {// this announcement is for the first logins set in admin
    let announcement = localstorage.get('announcementLogged');
    if(typeof announcement === 'object' && announcement?.value){ 
      let logged = JSON.parse(announcement?.value);
      if(logged?.url){ 
        watchMediaModal({
         url: logged?.url,
         header:"Welcome to Milestone!"
        }, async (result) => {
          console.log("result =>", result);
          // if(result?.progressTime){ 
          //   if(2 <= result?.progressTime?.playedSeconds){
              try{
                await http.post(`public/user/acknowledgeLogged`,
                  {
                    announcementID:logged?.id
                  }
                );
                  localstorage.remove('announcementLogged');
              }catch(e){
                console.error(e);
              }
          //   }
          //  }
        }); 
      } 
    }
   }

   const fetchAnnouncements = async ()=>{// this announcements is set for a schedule in admin
    try{
      let { data } = await http.get(`public/user/announcementsSchedule`,{},{},true);
      if(data){  
        scheduleAnnouncements(data); 
      }
    }catch(e){
      console.error(e);
    }
  }

  // useEffect(() => {
  //   fetchAnnouncements();

  //   const intervalId = setInterval(() => {
  //     fetchAnnouncements(); 
  //   }, 600000);

  //   return () => clearInterval(intervalId);
  // }, []);

  const scheduleAnnouncements = (announcements) => {
    announcements.forEach((announcement) => {
      const currentTime = new Date().getTime();
      const startTime = new Date(announcement.date_time).getTime();
      if (startTime <= currentTime) {
        watchMediaModal({
          url: announcement?.url,
          header:"Announcement from Milestones"
         }, async (result) => {
          //  if(result?.progressTime){
          //   if(2 <= result?.progressTime?.playedSeconds){ // acknowledge the announcement once the vid play atlease 20%
              try{
                await http.post(`public/user/acknowledgeLogged`,
                  {
                    announcementID:announcement?.id
                  }
                );
                  localstorage.remove('announcementLogged');
              }catch(e){
                console.error(e);
              }
          //   }
          //  }
           
         }); 
      }
    });
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setView('list'); // Set Tab 2 for mobile
      } else {
        setView('detailed'); // Set Tab 1 for web
      }
    };

    // Set initial tab based on current size
    handleResize();

    // Add resize event listener
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (refreshMilestones) {
      setRefreshMilestones();
    } else if (initializeMilestones) {
      if (!_.isEmpty(profile)) {
        setSwitchingProfile(false);
        if (featured) getFeaturedMilestone();
        fetchMilestones();
        getTagged();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initializeMilestones, refreshMilestones]);

  useEffect(() => {
    if (!_.isEmpty(profile)) {
      viewReportMilestone();
      getCategory();
      getPositions();
      addProfileView();
      getFollowing("following");
      getFollowing("followers");
      fetchProInfo();
      // fetch media button count
      (async () => {
        try {
          const { data } = await http.get("public/milestones/media-types/count");
          // expecting { count: number }
          setButtonCount(data?.count ?? 0);
        } catch (e) {
          console.error("error@fetchButtonCount", e);
          setButtonCount(0);
        }
      })();
      // fetch front page showreel (filtered by is_front_page_showreel)
      if(showreel !== null) return 
      (async () => {
        try {
          const { data } = await http.get("public/user-galleries", {
            user_profile_id: profile.id,
            type: "video",
            is_front_page_showreel: 1,
            limit: 1,
            page: 1,
          });
          const video = data?.data?.[0];
          setShowreel(video?.is_front_page_showreel ? video : null);
        } catch (e) {
          console.error("error@fetchShowreel", e);
          setShowreel(null);
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile]);
  

  useEffect(() => {
    if (username && profileId) {
      const uname = username.split("-")[0];

      if (userData) {
        if (userData?.user.username !== uname) getUserProfilePermission(uname);
        else setPermission({ status: "owner" });
      } 
      getUserProfile(uname);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [username, profileId]);

  useEffect(() => {
    if (query?.switchProfile) {
      switchProfile();
    }
    if (query?.viewPublic == false) {
      setViewPublic(false);
      getPinned(false);
      let user_data = JSON.parse(localStorage.getItem("user_data")); 
      let index = user_data?.profiles?.findIndex((p) => p?.id == profileId);
      if(index !== -1) setIsYourProfile(true);
      setRefreshMilestones(true);
    }
    else if (query?.viewPublicFilter == true) {
      setViewPublic(true);
      getPinned(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  useEffect(() => {
    let values = jobRole.map((jr) => jr.label);
    setFilterRoles(values);
  }, [jobRole]); 

  useEffect(() => { 
      let values = category.map((jr) => jr.label);
      setFilterCategories(values); 
  }, [category]); 
 

  useEffect(() => {
    let profileCtx = gsap.context(() => {
      gsap
        .fromTo(
          ".profile-first-row",
          { y: -20, opacity: 0 },
          { y: 0, opacity: 1 }
        )
        .duration(0.5);

      gsap
        .fromTo(
          ".profile-second-row",
          { opacity: 0 },
          { opacity: 1, duration: 1.5 }
        )
        .duration(0.5);

      // gsap
      //   .fromTo(".profile-about", { y: 30, opacity: 0 }, { y: 0, opacity: 1 })
      //   .duration(0.5);

      gsap
        .fromTo(
          ".profile-milestones",
          { y: 30, opacity: 0 },
          { y: 0, opacity: 1 }
        )
        .duration(0.5);
    }, profileRef);

    const container = containerStickyRef.current;
    container.addEventListener('scroll', handleScroll);

    return () => {
      profileCtx.revert();
      container.removeEventListener('scroll', handleScroll);
    }
  }, []);

  const milestone = new URLSearchParams(window.location.search).get(
    "milestone"
  );

  const hasOpenedModal = useRef(false);

  const share_link = ()=>{
    history.push('/sign-up'); 
  }
  useEffect(() => {
    if (!milestone) return;
    if (hasOpenedModal.current) return;
    hasOpenedModal.current = true;
    if (milestone) {
      let share = true;
      const hash_id = milestone;
      modalShare(
        {
          milestone,
          featured,
          userData,
          username,
          profileId,
          handleWatch,
          handleImageGallery,
          handleViewPdf,
          editMilestone,
          removeMilestone,
          _status,
          share,
          hash_id,
          profile,
          share_link,
          copyLink,
          reportMilestone
        },
        () => history.push(`${history.location.pathname}`)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [milestone]);
  //
  /** This method handle on scroll event */
  const handleScroll = () => {
    if (contentRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
      const middleThreshold = scrollHeight / 3;
      const topClientHeight = scrollTop + clientHeight;

      if (topClientHeight >= middleThreshold) {
        if (!_.isEmpty(profile)) {
          if(selectedTab === 'milestones'){
            fetchMilestones();
          }else if('resume' === selectedTab){
              fetchResume(); 
          }
        }
      }

      setScrollToTop(scrollTop);
    } 
    if (containerStickyRef.current) {
      const offsetTop = containerStickyRef.current.getBoundingClientRect().top;
      if(isMobile){
        setIsSticky(offsetTop <= 400);
        return;
      } 
      setIsSticky(offsetTop <= 260);
    }
  };

// useEffect(() => {
//       refreshResumes();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

  const fetchResume = async () => {
    let loadMore = false;
    try {
      if(isRequestingResume || !loadMoreResume) return;
      await getResume();
      const { data } = await http.get("public/resumes", {
        user_profile_id: profileId,
        skip: totalResume,
        limit:limitResume
      });
       loadMore = data.total > 0 ? true : false;
      const _total = parseInt(totalResume) + data.total;
      setResumes({resumes:data.resumes, total:_total, loadMore:loadMore, display_qr_reels:data.display_qr_reels});
      finishGetResume({loadMore:loadMore})
    } catch (err) {
      console.log(err);
      finishGetResume({loadMore:loadMore})
    }
  };

  // ============= use memo =================
  const showFilters = useMemo(() => {
    let emptyRoles = !_.isEmpty(filterRoles);
    let emptyOrganizeBy = !_.isEmpty(organizeBy);
    let emptyCateogory = !_.isEmpty(filterCategories);
    if (featured || emptyRoles || emptyOrganizeBy || emptyCateogory) {
      return true;
    } else {
      return false;
    }
  }, [featured, filterRoles, organizeBy, filterCategories,category]);

  // ============== milestone permision ===========
  const profilePermission = useMemo(() => {
    let obj = { hasMilestone: false, hasSocialMedia: false };
    if (!_.isEmpty(permission)) {
      const allowPermission = ["Super Admin", "Admin", "Staff"];
      const socialPermission = ["Super Admin", "Admin"];
      let isOwner = permission.status === "owner";
      let isAllowed = _.includes(allowPermission, permission?.permission?.name);
      let socialAllowed = _.includes(
        socialPermission,
        permission?.permission?.name
      );
      if (isOwner || isAllowed) {
        obj.hasMilestone = true;
      } else {
        obj.hasMilestone = false;
      }

      if (isOwner || socialAllowed) {
        obj.hasSocialMedia = true;
      } else {
        obj.hasSocialMedia = false;
      }
    } else {
      obj.hasMilestone = false;
      obj.hasSocialMedia = false;
    }

    return obj;
  }, [permission]);

  // const isOwnerProfile = useMemo(() => {
  //   if (userData && userData?.profile) {
  //     if (profile && userData?.profile.id === profile.id) {
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   } else {
  //     return false;
  //   }
  // }, [userData, profile]);

  const filterData = useMemo(() => {
    let result = "";
    let isEptyFilterRoles = !_.isEmpty(filterRoles);
    let isEmptyCategory = !_.isEmpty(filterCategories);
    let isEmptyOrganizeBy = !_.isEmpty(organizeBy);
    let isEmptySort = !_.isEmpty(sort);
    if (featured) {
      if (isEptyFilterRoles || isEmptyCategory || isEmptyOrganizeBy || isEmptySort) {
        result += ", ";
      }
    }
    if (isEptyFilterRoles) {
      result += filterRoles.join(", ");
    }
    if (isEptyFilterRoles) {
      if (isEmptyCategory || isEmptyOrganizeBy) {
        result += ", ";
      }
    }
    if (isEmptyCategory) {
      // result += category; 
      result += filterCategories.join(", ");
    }
    if (isEmptyCategory) {
      if (isEmptyOrganizeBy) {
        result += ", ";
      }
    }
    if (isEmptyOrganizeBy || isEmptySort) {
      result += `${t('organizeBy')} ${t(organizeBy)} ${sort && `- ${t(sort)}`}`;
    }
    return result;
  }, [featured, filterRoles, filterCategories, organizeBy,sort,t]);


  const showPersonalInformation = () => {
    if(isYourProfile) {
      return true;
    }

    /**
     * if user is not the current
     * then check if there is any personal info
     */
    if(isWithPersonalInfo) {
      return true;
    }

    return false;
  }

  const showProInformation = (hasInfo) => {
    if(isYourProfile) {
      return true;
    }

    /**
     * if user is not the current
     * then check if there is any prof info
     */
    if(hasInfo) {
      return true;
    }

    return false;
  }

  /**
   * 
   * @param {string} value 
   */
  const onSearchTextChange = useCallback((value) => {
    setMilestonesSearchText(value);
  }, []
)
  
  const hideInViewing = ()=>{
    if(viewPublic){
      return true;
    }else{
      return false;
    }
  }

  const getScrollableParent = (el) => {
    if (!el) return null;
    let parent = el.parentElement;
    while (parent) {
      try {
        const style = window.getComputedStyle(parent);
        const overflowY = style.overflowY;
        const isScrollable = (overflowY === 'auto' || overflowY === 'scroll') && parent.scrollHeight > parent.clientHeight;
        if (isScrollable) return parent;
      } catch (e) {}
      parent = parent.parentElement;
    }
    return null;
  }

  const scrollTriggerIntoView = (triggerEl) => {
    try {
      const el = triggerEl || optionTriggerRef.current;
      if (!el) return;

      const container = getScrollableParent(el) || contentRef.current || document.scrollingElement || document.documentElement;

      const elRect = el.getBoundingClientRect();
      const containerRect = container === document.scrollingElement || container === document.documentElement
        ? { top: 0, left: 0 }
        : container.getBoundingClientRect();

      const scrollTop = container.scrollTop || window.scrollY || 0;
      const offsetTop = elRect.top - containerRect.top + scrollTop;
      const offsetBottom = elRect.bottom - containerRect.top + scrollTop;

      const visibleTop = scrollTop;
      const visibleBottom = scrollTop + (container.clientHeight || window.innerHeight);

      if (offsetBottom > visibleBottom - 60) {
        const target = offsetBottom - (container.clientHeight - 140);
        container.scrollTo({ top: Math.max(target, 0), behavior: 'smooth' });
      } else if (offsetTop < visibleTop + 20) {
        const target = Math.max(offsetTop - 20, 0);
        container.scrollTo({ top: target, behavior: 'smooth' });
      }
      setTimeout(() => {
        setShowMoreOptionMile(true);
      }, 300);
    } catch (e) {
      try { triggerEl?.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) {}
    }
  }


  const previewBTN = ()=>{
    if((showFilters && !hideInViewing() && isYourProfile)){
      return <Button
                buttonName={t('seePublicView')}
                buttonTextClass="text-xs 2sm:text-sm font-semibold flex items-center justify-center text-black"
                buttonRadius="6px"
                iconPosition="left"
                icon={<FiEye  className="mr-2" />}
                buttonClass="relative py-3 px-3.5 bg-gray hover:bg-gray w-full 2sm:w-fit btn-add-milestone"
                onClick={()=>{
                      const url = new URL(window.location.href);
                      url.searchParams.set('viewPublic', 'true');
                      history.push(url.pathname + url.search,
                        {
                          viewPublic: true
                        }
                      );
                      setIsYourProfile(false);
                      setViewPublic(true);
                      getPinned(true);
                      setRefreshMilestones(true);
                }}
              />
    } 
  } 
  useEffect(() => {
      window.addEventListener(
        "scroll",
        () => {
          if (optionListRef.current) {
            optionListRef.current.close();
          }
        },
        true
      );
    }, []);
  return (
    showNoProfileFound
      ? <Layout
      title="Profile"
      contentRef={contentRef}
      handleScroll={handleScroll}
      setUserData={setUserData}
      containerStyle="lg:static lg:overflow-y-auto overflow-x-hidden"
      isYourProfile={isYourProfile}
      allowBanner={true}
      setSelectedTab={setSelectedTab}
      >
        {/* !!! */}
          <div ref={profileRef} className="profile-page-wrapper no-profile-found flex items-center justify-center">
            {/* No Profile Found Page -> Displayed or unauthenticated users accessing a profile with adult content. */}
            <div className="bg-white rounded-md w-11/12 h-5/6 xl:w-8/12:h-4/5 flex flex-col items-center justify-center">
            {/* <div className="bg-white rounded-md w-8/12 h-4/5 flex flex-col items-center justify-center"> */}
              <NoProfileFoundIconSvg />
              <p className="mt-6 font-semibold text-2xl">Profile cannot be found</p>
              <p className="mt-2 font-semibold text-base">This profile is not publicly available</p>
              <Button
                buttonName="Back to my profile"
                buttonClass="bg-thBg py-4 px-8 hover:bg-gray mt-6"
                buttonTextClass="text-black text-sm font-semibold"
                // onClick={() => hide()}
                path="/login"
                link={true}
              />
            </div>
          </div>
      </Layout>
      : <Layout
        title="Profile"
        contentRef={contentRef}
        handleScroll={handleScroll}
        setUserData={setUserData}
        containerStyle="lg:static lg:overflow-y-auto overflow-x-hidden"
        isYourProfile={isYourProfile}
        allowBanner={true}
        setSelectedTab={setSelectedTab}
        >  
        {/* dialog Report*/}
        {/* {reportViewDialog()} */}
        {/* overflow-y-auto scroll-smooth custom-scroll */}
        <div ref={profileRef} className="profile-page-wrapper pt-4 3md:pt-8.5  ">
        {
          isSticky &&
          <>
            <div className={`top-0 navbar flex flex-col w-full z-50 ${isSticky ? 'fixed' : ''}`}>
              <div className={`bg-white w-full top-0 navbar flex z-50 py-3 profile-page-wrapper-padding justify-between shadow-md cursor-pointer gap-2`}>
                {
                  !showSearch && 
                  <>
                    <div className="flex items-center gap-2">
                      {/* TODO: remove "hidden" in the future below */}
                      <div className="hidden md:flex flex-row items-center">
                        <a href="https://milestonespage.com/">
                          <img src={logo} alt="milestone logo" className="w-10 h-10"/>
                        </a>
                        <div className="w-[1px] h-[1.375rem] bg-[#DDD] ml-4 mr-3 lg:ml-3 lg:mr:2"/>
                      </div>
                      <div className="relative rounded-md">
                        <ProfilePhoto
                          className="w-10 2sm:w-10"
                          image={
                            isGif
                                ? profile.profile_image_url
                                : profile?.profile_image_webp_url || profile?.profile_image_url || ProfileDefaultPlaceholder
                            }
                          source = {profile?.profile_image_url || ProfileDefaultPlaceholder}
                        />
                      </div>
                        <p className="limit-2-lines">{isYourProfile ? 
                          ((profile?.translation?.[currentLang()]?.[profile?.profile_name] || profile?.profile_name)  ||
                          `${ profile?.translation?.[currentLang()]?.[userData?.user?.first_name] || userData?.user?.first_name}
                          ${profile?.translation?.[currentLang()]?.[userData?.user?.last_name] ||userData?.user?.last_name}`)
                          : ((profile?.translation?.[currentLang()]?.[profile?.profile_name] || profile?.profile_name)
                              || (profile?.translation?.[currentLang()]?.[profile?.user?.username] || profile?.user?.username))}
                        {profile?.id3_verified && (
                            <span className="inline-flex items-center align-middle"><VerifyIconSVG className="w-5 h-5 3md:w-5 3md:h-5 mx-2 3md:ml-2.5" /></span>
                          )}
                        </p>
                    </div>
                    <ProfileSocials
                      onReport={reportMilestone}
                      userData={userData}
                      profile={profile}
                      isYourProfile={isYourProfile}
                      viewPublic={viewPublic}
                      hasPermission={profilePermission.hasSocialMedia}
                      onClickMessage={handleSendMessage}
                      showSocialMedia={false}
                      isSticky={isSticky}
                      handleUpdateTranslate={handleUpdateTranslate}
                      fetchSocMed={fetchSocMed}
                      setProfile={setProfile} 
                    />
                  </>
                }
                {
                  _.isEmpty(userData) &&
                  <div className="transition-all duration-300 delay-250 flex items-center block 2md:hidden">
                      <LoginSingup showSearchIcon={true}
                        variant="black" 
                        textSignup="Join" 
                        textClass="text-black" 
                        buttonClass="flex items-center my-1 py-1.5"
                        searchBtn = {(value)=>{setShowSearch(value)}}
                        />
                  </div>
                }
              </div>
            {
              (closeAlertBar) &&
              <div className="profile-page-wrapper-padding bg-lightBlack">
                {
                  isYourProfile && viewPremiumBar && subscription?.name === 'Free Account' && (userData?.user.reg_status!='freemium' && userData?.user.reg_status!='lifetime') ?
                  <AlertBar
                  content={() => {
                    return(
                      <span class="text-verified font-semibold">
                        {t('upgradeToPremium')}  
                        <Link to="/plans" className="ml-1 hover:text-gray underline font-semibold">
                          {t('clickHere')}
                        </Link>
                      </span>
                    )
                  }}
                  onClose={()=>{setCloseBar(false); setPremium(false); localStorage.setItem('premium-bar', JSON.stringify(false))}}
                  showBtnExit={true}
                />: 
                _.isEmpty(userData?.profile) ?
                <AlertBar
                  content={() => {
                    return(
                      <span class="text-verified">
                        {t('createYourMilestones')} - 
                        <Link to="/sign-up" className="ml-1 hover:text-gray font-semibold">
                          {t('clickHere')}
                        </Link>
                      </span>
                    )
                  }}
                  onClose={()=>setCloseBar(false)} 
                />
                : viewPublic ?
                <AlertBar
                  content={() => {
                    return(
                      <span class="text-verified">
                        <GlobeIconSVG className="w-[25px] inline-block mr-1" />
                        {t('publicViewMessage')}
                      </span>
                    )
                  }}
                  onClose={()=>{
                    const url = new URL(window.location.href);
                    url.searchParams.delete('viewPublic');
                    history.push(url.pathname + url.search,
                      {
                        viewPublic: false,
                        viewPublicFilter: false
                      }
                    );
                    setCloseBar(false)}
                  } 
                  onCloseText={t('exit')}
                />: null
                }
                
              </div>
            }
            </div>
          </>
        }
          {/* {
            (!showOnboarding && isYourProfile && viewPremiumFooter && subscription?.name === 'Free Account' && (userData?.user.reg_status!='freemium' && userData?.user.reg_status!='lifetime')) &&
            <div className={`bottom-0 navbar w-full z-50 absolute`}>
              <FooterPremium
              shshowSecondPremow = {isYourProfile && subscription?.name === 'Free Account' && (userData?.user.reg_status!='freemium' && userData?.user.reg_status!='lifetime')}
              />
            </div>
            } */}
          {/* 1st row */}
          <div className="profile-first-row w-full profile-page-wrapper-padding">
            <div className="w-full bg-white rounded-md container-max-width">
              {/* cover photo */}
              {(Object.keys(profile).length === 0 || switchingProfile) && (
                <SkeletonLoading classStyle="skeleton-item w-full h-400" />
              )}
              {Object.keys(profile).length !== 0 && !switchingProfile && (
                <ProfileCoverPhoto
                  image={
                    profile?.cover_image_webp_url ||
                    profile.cover_image_url ||
                    CoverDefaultPlaceholder
                  }
                />
              )}
              {/* profile details */}
              <div className="w-full relative px-5 2sm:px-10 3md:px-24.5 pb-4 pt-10 3md:pb-10">
                {/* profile picture */}
                {(Object.keys(profile).length === 0 || switchingProfile) && (
                  <SkeletonLoading classStyle="skeleton-item w-40 h-40" />
                )}
                {Object.keys(profile).length !== 0 && !switchingProfile && (
                  <ProfilePhoto
                    image={
                      isGif
                        ? profile.profile_image_url
                        : profile?.profile_image_webp_url || profile?.profile_image_url || ProfileDefaultPlaceholder
                    }
                    source={profile?.profile_image_url || ProfileDefaultPlaceholder}
                  />
                )}
                {/* settings  */}
                <div className="w-full">
                  <div className="w-full flex justify-center 2sm:justify-end mt-8 2sm:mt-0">
                    {profile?.hero?.link ? (
                      <ToolTip
                        value={`
                        ${heroCTAs.filter((hs) => hs.value === profile?.hero?.heroCTA)[0]?.label || t('supportMeOn')}
                        ${profile?.hero?.socialMedia === "Other" ? 
                          (profile?.hero?.other_hero_social_media || profile?.hero?.socialMedia)  : 
                          heroTypes.find(item => item.value === profile?.hero?.socialMedia)?.label}`}
                        backgroundColor="#0c6ed1"
                        color="white">
                        <div className="hidden 5sm:block">
                          <button
                          className="text-xs font-semibold text-lightBlack flex items-center
                          3md:mb-0 3md:py-2 3md:h-[3.125rem] px-[1.125rem] bg-thBg hover:bg-gray gap-1 rounded-md group-hover:opacity-100 max-w-[14rem] justify-between"
                          disabled={viewPublic}
                          onClick={() =>
                            window.open(profile?.hero.link, "_blank")
                          }>
                            <p className="mt-0.5">
                              {/* {profile?.hero?.heroCTA || "Show your support on"} */}
                              {heroCTAs.filter((hs) => hs.value === profile?.hero?.heroCTA)[0]?.label || t('supportMeOn')}
                            </p>
                            {heroIcon(profile?.hero?.socialMedia,profile?.hero.link)}
                          </button>
                        </div>
                      </ToolTip>
                    ) : (
                      <div
                        className=" w-full flex justify-end hidden 5sm:block"
                        style={{ height: 45 }}>
                        &nbsp;
                      </div>
                    )}
                  </div>
                </div>
                {/* content details */}
                <div className="w-full 3md:flex 3md:justify-between 3md:items-center">
                  {/* 1st col */} 
                  <ProfileDetails data={profile} isYourProfile={isYourProfile} userData={userData} socMed={socMed}/>
                  {/* 2nd col */}
                  {profile?.hero?.link && (
                  <div className="block 5sm:hidden">
                    
                      <button
                      className="w-full text-xs font-semibold text-lightBlack flex items-center
                      3md:mb-0 3md:py-4 px-3 bg-thBg hover:bg-gray gap-1 rounded-md group-hover:opacity-100  justify-center my-2 hero-button"
                      disabled={viewPublic}
                      onClick={() =>
                        window.open(profile?.hero.link, "_blank")
                      }>
                        <p className="mt-0.5">
                          {profile?.hero?.heroCTA || "Show your support on"}
                        </p>
                        {heroIcon(profile?.hero?.socialMedia,profile?.hero.link)}
                      </button>
                    </div>
                    )}
                  {/* 3nd col */}
                  {
                    !switchingProfile && (
                      <ProfileSocials
                      onReport={reportMilestone}
                      userData={userData}
                      profile={profile}
                      isYourProfile={isYourProfile}
                      viewPublic={viewPublic}
                      hasPermission={profilePermission.hasSocialMedia}
                      onClickMessage={handleSendMessage}
                      handleUpdateTranslate={handleUpdateTranslate}
                      fetchSocMed={fetchSocMed}
                      setProfile={setProfile} 
                      displayTooltip={true}
                    />
                    )
                  }

                </div>
                {/* end: content details */}
              </div>
            </div>
          </div>
          {/* 2nd row */}
          <DefaultTabs
            {...{
              profile,
              userData,
              selectedTab,
              setSelectedTab,
              checkDomain,
              isYourProfile,
              taggedMilestones,
              pendingCount: isYourProfile ? pendingTagged.length : 0,
            }}
            emptyAbout = {!isYourProfile && isWithProInfo === false && isWithPersonalInfo === false}
          />

          {/* Ad Show Video Reel in Mileston only */}
          {selectedTab === "milestones" && showreel?.link && (
            <div className="mt-8.5 w-full profile-page-wrapper-padding">
              <div
                className="relative w-full aspect-video bg-primary rounded-md overflow-hidden cursor-pointer"
                onClick={() => handleWatch("Showreel", showreel.link, showreel.orientation)}>
                {showreel.media?.webp_url || showreel.media?.url ? (
                  <img
                    src={showreel.media?.webp_url || showreel.media?.url}
                    alt="Showreel"
                    className="absolute inset-0 w-full h-full object-cover object-center"
                  />
                ) : (
                  <img
                    src={LogoWhite}
                    alt="Showreel"
                    className="absolute inset-0 m-auto w-[38%] opacity-50"
                  />
                )}
                <div className="absolute top-3 left-3 sm:top-6 sm:left-6 flex items-center gap-2 bg-black/40 text-white font-semibold text-sm sm:text-xl rounded-md px-3 py-1.5 sm:px-4 sm:py-2">
                  <GoStarFill className="text-[#FF9E59]" />
                  Showreel
                </div>
                <PlayIconCircleWhiteSVG className="absolute inset-0 m-auto w-14 h-14 sm:w-28 sm:h-28" />
              </div>
            </div>
          )}
          {/* end: Ad Show Video Reel in Mileston only */}

          {/* 3rd row */}
          <div className="w-full mt-5" ref={containerStickyRef}>
            <TabPanel className="profile-about" hidden={selectedTab !== "about"}>
              <div className="w-full profile-page-wrapper-padding">
                {profile?.profile_type?.type === "group" ||
                profile?.profile_type?.type === "team" ||
                profile?.profile_type?.type === "business"
                 ? (
                  <>
                    {profile?.id && (
                      <div className="w-full mt-6 container-max-width">
                        <GroupMembers
                          userData={userData}
                          profile={profile}
                          setUserData={setUserData}
                          isYourProfile={isYourProfile}
                        />
                      </div>
                    )}
                    {profile?.id && (
                      <div className="w-full mt-6 container-max-width">
                        <GroupTeam
                          userData={userData}
                          profile={profile}
                          setUserData={setUserData}
                          isYourProfile={isYourProfile}
                          onDoneUpdate={(data) => {
                           setProfile({
                            ...profile,
                            ...data.profile
                           });
                          }}
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    {profile?.id && showPersonalInformation() && (
                      <div className="w-full mt-6 container-max-width">
                        <PersonalInformation
                          userData={userData}
                          profile={profile}
                          setUserData={setUserData}
                          isYourProfile={isYourProfile}
                          onDoneUpdate={(data) => {
                           setProfile({
                            ...profile,
                            ...data.profile
                           });
                          }}
                        />
                      </div>
                    )}
                    {profile?.id && (
                      <div className={`w-full mt-6 container-max-width ${showProInformation(hasProInfo) ? "" : "hidden"}`}>
                        <ProfessionalInformation
                          userData={userData}
                          profile={profile}
                          setUserData={setUserData}
                          isYourProfile={isYourProfile}
                          onHasProfessionalInfoChange={(hasInfo) => {
                            setHasProInfo(hasInfo);
                          }}
                        />
                      </div>
                    )}

                    {  !showPersonalInformation() && !showProInformation(hasProInfo) && (
                      <div className="w-full mt-6 container-max-width p-6 rounded bg-white text-center font-bold text-darkerGray">No Information yet</div>
                    )}
                  </>
                )}
              </div>
            </TabPanel>
            {/*  */}
            <TabPanel
              className="profile-milestones"
              hidden={selectedTab !== "milestones"}>
              <div className="w-full profile-page-wrapper-padding ">
                {/* header */}
                <div className="block 3md:hidden">
                  <div className="w-full flex items-center justify-between">
                    <div className="flex space-x-2 items-center">
                      <p className="text-lg 2sm:text-2xl font-bold text-lightBlack">
                          Milestones
                      </p>
                    {/* pop info */}
                      <PopInfo type={selectedTab === 'tagged' ? 'tagged_milestones' : isYourProfile ? 'milestones_not_login' : 'milestones_not_login'} 
                      responsive={{
                        left: "104px",
                        right: "104px",
                      }}
                      />
                    </div>
                    {/* {showFilters && (
                      <button
                        className="bg-tagBorder py-1 px-2 rounded-md text-4xs font-semibold text-lightBlack items-center hidden 3md:flex"
                        onClick={clearFilters}>
                        <MdClose />
                        Clear filters
                      </button>
                    )} */}
                    <div className="flex 3md:hidden justify-center gap-2">
                      {
                        previewBTN()
                      }
                      <GroupButton
                        active={view}
                        onClick={(value) => setView(value)}
                      />
                    </div>
                  </div>
                  <div className="w-full 2sm:flex 2sm:justify-between 2sm:items-center">
                    <div className="w-full flex mt-3 gap-2">
                        {(profile.milestone_filter && isYourProfile)  && (
                          <>
                          <p className="text-xs 2sm:text-sm text-lightBlack leading-6">
                          <span className="">{t('viewToDefault?')} </span>
                          </p>
                            <button
                              className="bg-tagBorder py-1 px-2 rounded-md text-4xs 2sm:text-xs font-semibold text-lightBlack flex items-center 2sm:flex 3md:hidden"
                              onClick={clearFilters}>
                              <MdClose />
                              Clear filters
                            </button>
                          </>
                         )}
                      {
                        ((!isYourProfile && showFilters) || (profile.milestone_filter === null && isYourProfile  && showFilters)) &&
                        <>
                          <p className="text-xs 2sm:text-sm text-lightBlack leading-6">
                            <span className="font-semibold">{t('currentFilters')}: </span>
                            <span>
                              {featured && "Pinned Only"}
                              {filterData}
                            </span>
                        </p> 
                          <button
                            className="bg-tagBorder py-1 px-2 rounded-md text-4xs 2sm:text-xs font-semibold text-lightBlack flex items-center 2sm:flex 3md:hidden"
                            onClick={clearFilters}>
                            <MdClose />
                            Clear filters
                          </button> 
                        </>
                      }
                    </div>
                    {/* <div className="hidden 2sm:block 3md:hidden">
                      <GroupButton
                        active={view}
                        onClick={(value) => setView(value)}
                      />
                    </div> */}
                  </div>
                </div>
                <div
                  className={`w-full flex 2sm:hidden items-center justify-between 2md:space-x-2 container-max-width 3md:flex`}>
                  <div className="w-full flex flex-col 2sm:flex-row items-center justify-between">
                    <div className="flex items-center justify-start space-x-6 w-full 2sm:w-auto">
                      <div className="w-full 2sm:w-fit">
                      {profilePermission.hasMilestone ? (
                        <>
                            {
                              !profile?.quick_create_milestone ?
                              <button
                              ref={optionTriggerRef}
                              onMouseDown={(e) => scrollTriggerIntoView(e.currentTarget || optionTriggerRef.current)}
                              onClick={() => 
                              {
                                  addMilestone()
                                
                              }
                            }
                            className="relative rounded-md py-3.5 2sm:py-5 px-5 2sm:px-10 bg-primary hover:bg-darkPrimary w-full 2sm:w-fit btn-add-milestone mt-4 mb-2">
                            <div className="text-xs 2sm:text-sm text-white font-semibold flex items-center justify-center" >
                                <FaPlus className="mr-2" />
                                <h3>{t('addMilestone')}</h3>
                            </div>
                          </button>
                          :
                           <Popup
                              ref={optionListRef}
                              position="bottom center"
                              arrow={false}
                              open={showMoreOptionMile}
                              onClose={() => setShowMoreOptionMile(false)}
                              contentStyle={{
                                marginTop: 5,
                                left:10
                              }}
                              trigger={
                                <button
                                  ref={optionTriggerRef}
                                  onMouseDown={(e) => scrollTriggerIntoView(e.currentTarget || optionTriggerRef.current)}
                                  onClick={() => setShowMoreOptionMile(true)}
                                  className="relative rounded-md py-3.5 2sm:py-5 px-5 2sm:px-10 bg-primary hover:bg-darkPrimary w-full 2sm:w-fit btn-add-milestone mt-4 mb-2">
                                  <div className="text-xs 2sm:text-sm text-white font-semibold flex items-center justify-center" >
                                      <FaPlus className="mr-2" />
                                      <h3>{t('addMilestone')}</h3>
                                  </div>
                                </button>
                              }
                            > 
                             {
                              isMobile ?
                                <MenuBottom title={t('addMilestone')} closeMoreOption={()=>optionListRef.current.close()}>
                                    <ul className="flex flex-col shadow-lg rounded-md bg-white w-full ">
                                      <li className="hover:bg-gray hover:rounded-t-md" onClick={addQuickMilestone}>
                                        <button
                                          className="flex flex-row items-center text-base px-6 py-2 gap-4"
                                          >
                                            <IoAddCircleOutline />
                                            {t('quickCreate')}
                                        </button>
                                      </li>
                                      <li className="hover:bg-gray hover:rounded-t-md" onClick={addMilestone}>
                                        <button
                                          className="flex flex-row items-center text-base px-6 py-2 gap-4" >
                                            <IoCogSharp/>
                                            {t('advancedCreate')}
                                        </button>
                                      </li>
                                    </ul>
                                </MenuBottom>
                                :
                                  <ul className="flex flex-col shadow-lg rounded-md bg-white w-full ">
                                    <li className="hover:bg-gray hover:rounded-t-md">
                                      <button
                                        className="flex flex-row items-center text-base px-6 py-2 gap-4"
                                        onClick={addQuickMilestone}>
                                          <IoAddCircleOutline />
                                          {t('quickCreate')}
                                      </button>
                                    </li>
                                    <li className="hover:bg-gray hover:rounded-t-md">
                                      <button
                                        className="flex flex-row items-center text-base px-6 py-2 gap-4"
                                        onClick={addMilestone}>
                                          <IoCogSharp/>
                                          {t('advancedCreate')}
                                      </button>
                                    </li>
                                  </ul>
                             }                       
                              
                            </Popup> 
                            }                        
                        </>
                        
                      ) : (
                        <div className="flex space-x-2 items-center hidden 2sm:flex">
                          <p className="text-3xl text-lightBlack font-bold tracking-tighter">
                            Milestones
                          </p>
                          {/* pop info */}
                          <PopInfo type={selectedTab === 'tagged' ? 'tagged_milestones' : isYourProfile ? 'milestones_not_login' : 'milestones_not_login'} />
                        </div>
                      )}
                    </div>
                    {!userData && (
                      <div className="hidden 2md:block">
                        <LineVerticalSVG />
                      </div>
                    )}
                    <div className="hidden 3md:flex items-center mt-1">
                      {(profile.milestone_filter && isYourProfile)  && (
                          <>
                          <p className="text-xs 2sm:text-sm text-lightBlack leading-6">
                          <span className="">{t('viewToDefault?')} </span>
                          </p>
                            <button
                              className="bg-thBg py-2 px-3.5 rounded-md text-base font-semibold text-lightBlack leading-4 flex items-center"
                              onClick={clearFilters}>
                              <MdClose />
                              {t('clearFilters')}
                            </button>
                          </>
                         )}
                      {
                        ((!isYourProfile && showFilters) || (profile.milestone_filter === null && isYourProfile && showFilters)) &&
                        <>
                          <p className="text-xs 2sm:text-sm text-lightBlack leading-6">
                            <span className="font-semibold">{t('currentFilters')}: </span>
                            <span>
                              {featured && "Pinned Only"}
                              {filterData}
                            </span>
                        </p> 
                          <button
                            className="bg-thBg py-2 px-3.5 rounded-md text-base font-semibold text-lightBlack leading-4 flex items-center"
                            onClick={clearFilters}>
                            <MdClose />
                            {t('clearFilters')}
                          </button> 
                        </>
                      }
                    </div>
                    </div>
                    <div className="hidden 3md:flex justify-center">
                      {
                       previewBTN()
                      }
                    </div> 
                  </div>
                  {/*  */}
                  <div className="hidden 3md:flex justify-center">
                    <GroupButton
                      active={view}
                      onClick={(value) => setView(value)}
                    />
                  </div>
                </div>
                {/* selects component */}
                {view !== "column" && (
                  <ListFilter
                    positions={options.positions}
                    categories={options.categories}
                    active={view}
                    onClick={(value) => setView(value)}
                    permission={permission}
                    addMilestone={addMilestone}
                    isYourProfile={isYourProfile}
                    profile={profile}
                    userData={userData}
                    showFilters={showFilters}
                    setProfile={setProfile}
                    hideInViewing={hideInViewing}
                    {...{
                      jobRole,
                      category,
                      organizeBy,
                      featured,
                      onChangeJobRole,
                      onChangeCategory,
                      onChangeOrganizeBy,
                      onChangeFeaturedOnly,
                      sort,
                      customOrderJR,
                      customOrderCAT,
                      http,
                      localstorage,
                      searchTextDefaultValue: milestonesSearchtext,
                      onSearchTextChange
                    }}
                  />
                )}
                {/*  */}
              </div>
              <div className="w-full mt-5">
                <div className="w-full milestone-page-wrapper">
                  {/*  */}
                  {view === "detailed"
                    ? renderDetailedListView()
                    : view === "list"
                    ? renderListView()
                    : renderColumnView()}
                  {/*  */}
                  <LoadMore
                    selectedTab={selectedTab}
                    result={
                      featuredMilestone.length ||
                      currentMilestones.length ||
                      upcomingMilestones.length ||
                      pastMilestones.length ||
                      milestones.length
                        ? true
                        : false
                    }
                    requesting={isRequesting}
                    initialize={initializeMilestones}
                    loadMore={loadMoreMilestones}
                  />
                </div>
              </div>
            </TabPanel>
            <TabPanel
              className="profile-photos-videos"
              hidden={selectedTab !== "photos-video"}>
              <div className="w-full profile-page-wrapper-padding">
                <div className="w-full mt-6 container-max-width">
                  <PhotosVideos
                    userData={userData}
                    profile={profile}
                    title="Photos"
                    buttonTitle="Add Photos"
                    type="photo"
                    isOwner={profile?.id === userData?.profile.id}
                  />
                </div>
                <div className="w-full mt-6 container-max-width">
                  <ManageVideos userData={userData} profile={profile} onVideosChanged={handleVideosShowreelSync} />
                </div>
              </div>
            </TabPanel>
            <TabPanel
              className="profile-tagged"
              hidden={selectedTab !== "tagged"}>
              <div className="w-full profile-page-wrapper-padding ">
                <div
                  className={`w-full flex 2sm:hidden items-center justify-between 2md:space-x-2 container-max-width 3md:flex`}>
                  <div className="w-full flex flex-col 2sm:flex-row items-center justify-between">
                    <div className="flex items-center justify-start space-x-6 w-full 2sm:w-auto">
                      <div className="w-full 2sm:w-fit">
                        <div className="flex space-x-2 items-center hidden 2sm:flex">
                          <p className="text-3xl text-lightBlack font-bold tracking-tighter">
                            {selectedTab === 'tagged' ? 'Tagged Milestones' : 'Milestones'}
                          </p>
                          {/* pop info */}
                          <PopInfo type={selectedTab === 'tagged' ? 'tagged_milestones' : isYourProfile ? 'milestones_not_login' : 'milestones_not_login'} />
                        </div>
                    </div>
                    {!userData && (
                      <div className="hidden 2md:block">
                        <LineVerticalSVG />
                      </div>
                    )}
                    </div>
                  </div>
                  {/*  */}
                  <div className="hidden 3md:flex justify-center">
                    <GroupButton
                      active={view}
                      onClick={(value) => setView(value)}
                    />
                  </div>
                </div>
              </div>
              <div className="w-full profile-page-wrapper-padding ">
                {/* header */}
                <div className="block 3md:hidden">
                  <div className="w-full flex items-center justify-between">
                    <div className="flex space-x-2 items-center">
                      <p className="text-lg 2sm:text-2xl font-bold text-lightBlack">
                          Tagged Milestones
                      </p>
                    {/* pop info */}
                      <PopInfo type="tagged_milestones" />
                    </div>
                    <div className="flex 3md:hidden justify-center gap-2">
                      {
                        previewBTN()
                      }
                      <GroupButton
                        active={view}
                        onClick={(value) => setView(value)}
                      />
                  </div>
                  </div>
                </div>
              </div>
              {/* Newly Tagged Milestones — awaiting the owner's decision. Shown
                  above the decided list in every view; hidden when nothing is
                  pending. Nothing here affects the profile until decided. */}
              {isYourProfile && pendingTagged.length > 0 && (
                <div className="w-full profile-page-wrapper-padding mt-5">
                  <div className="w-full container-max-width">
                    <Collapsible
                      title={() => (
                        <p className="milestone-title text-lightBlack font-bold text-base 2sm:text-xl 3md:text-2xl leading-7.5 tracking-tighter">
                          {t("newlyTaggedMilestones", "Newly Tagged Milestones")} ({pendingTagged.length})
                        </p>
                      )}
                      content={() => (
                        <>
                          {pendingTagged.map((obj, index) => {
                            const date = formatDate(obj, userData?.profile?.dateFormat, t);
                            const thumbnail = obj.thumbnail
                              ? obj.thumbnail.webp_url || obj.thumbnail.url
                              : null;
                            return (
                              <DetailedTagViewCard
                                key={`pending-${index}-${obj.id}`}
                                dataId={obj.id}
                                profile={obj.profile}
                                featured={obj}
                                details={obj}
                                url={thumbnail}
                                viewUrl={thumbnail}
                                title={obj.title}
                                dateNote={obj.date_note}
                                date={date}
                                people={obj.people}
                                positions={obj.positions}
                                platform={obj.platform}
                                location={obj.location}
                                description={obj.description}
                                privacy={obj.privacy}
                                isPrivate={obj.is_private}
                                isAdultContent={obj.is_adult_content ? true : false}
                                categories={obj?.categories}
                                buttons={obj.media_type}
                                onWatchMedia={handleWatch}
                                onViewImage={handleImageGallery}
                                handleViewPdf={handleViewPdf}
                                pending={true}
                                onDecide={(isPrivate) => decideTaggedMilestone(obj, isPrivate)}
                                onRemoveTag={() => confirmRemoveTag(obj)}
                                isYourProfile={true}
                                mention_names={obj.mention_names}
                                userData={userData}
                                group="pending"
                                indexPopUp={index}
                              />
                            );
                          })}
                        </>
                      )}
                    />
                  </div>
                </div>
              )}
              <div className="w-full mt-5">
                <div className="w-full milestone-page-wrapper">
                  {/*  */}
                  {view === "detailed"
                    ?
                      <DetailedViewMilestones /**I directly add the component to avoid duplicate the content vice versa with milestone tab and tagged */
                          key={"tagged"}
                          setTutMile={setTutMile}
                          showTutMilestone={showTutMilestone}
                          showFeatured={featured}
                          featured={featuredMilestone}
                          current={currentMilestones}
                          past={pastMilestones}
                          pin={pinnedMilestones}
                          tagged={taggedMilestones}
                          tagView={true}
                          upcoming={upcomingMilestones}
                          onWatchMedia={handleWatch}
                          onViewImage={handleImageGallery}
                          handleViewPdf={handleViewPdf}
                          togglePrivacyTaggedMilestone={togglePrivacyTaggedMilestone}
                          onEdit={editMilestone}
                          onDelete={removeMilestone}
                          onReport={reportMilestone}
                          onRemoveTag={onRemoveTag}
                          isYourProfile={isYourProfile}
                          profile={userData?.profile}
                          permission={permission}
                          onShare={shareMilestone}
                          milestone_owner={profile}
                          translateMilestone={translateMilestone}
                          onAnalytics={viewAnalytics}
                          onCopyLink={copyLink}
                          userData={userData}
                          updateMilestonesState={updateMilestonesState}
                        />
                    : view === "list"
                    ? renderListView()
                    : renderColumnView()}
                  {/*  */}
                  <LoadMore
                    selectedTab={selectedTab}
                    result={
                      featuredMilestone.length ||
                      currentMilestones.length ||
                      upcomingMilestones.length ||
                      pastMilestones.length ||
                      milestones.length
                        ? true
                        : false
                    }
                    requesting={isRequesting}
                    initialize={initializeMilestones}
                    loadMore={loadMoreMilestones}
                  />
                </div>
              </div>
            </TabPanel>
            <TabPanel className="resume" hidden={selectedTab !== "resume"}>
                <div className="w-full profile-page-wrapper-padding">
                  <div className="w-full mt-6 container-max-width">
                    <ResumeList
                      profile={profile}
                      username={username}
                      profileId={profileId}
                    />
                  </div>
                </div>
            </TabPanel>
          </div>
        </div>
        {/** floating button */}
        {selectedTab === "milestones" && scrollToTop > 1000 && (
          <FabButton onClick={scrollTop}>
            <FiChevronUp className="text-5xl" />
          </FabButton>
        )}
      </Layout>
  );
};
const mapStateToProps = (state) => {
  return {
    userData: state.user.userData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setUserData: (params) => {
      dispatch(userActions.setUserData(params));
    },
  };
};
const useQuery = () => {
  const { state } = useLocation();

  return React.useMemo(() => state, [state]);
};
export default connect(mapStateToProps, mapDispatchToProps)(Profile);